[
  {
    "codigo": "0100100",
    "descricao": "Catalisadores em colmeia cerâmica ou metálica para conversão catalítica de gases de escape de veículos e outros catalisadores",
    "ncms": [
      "38151210",
      "38151290"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0100200",
    "descricao": "Tubos e seus acessórios (por exemplo, juntas, cotovelos, flanges, uniões), de plásticos",
    "ncms": [
      "3917"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0100300",
    "descricao": "Protetores de caçamba",
    "ncms": [
      "39181000"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0100400",
    "descricao": "Reservatórios de óleo",
    "ncms": [
      "39233000"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0100500",
    "descricao": "Frisos, decalques, molduras e acabamentos",
    "ncms": [
      "39263000"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0100600",
    "descricao": "Correias de transmissão de borracha vulcanizada, de matérias têxteis, mesmo impregnadas, revestidas ou recobertas, de plástico, ou estratificadas com plástico ou reforçadas com metal ou com outras matérias",
    "ncms": [
      "40103",
      "59100000"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0100700",
    "descricao": "Juntas, gaxetas e outros elementos com função semelhante de vedação",
    "ncms": [
      "40169300",
      "4823909"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0100800",
    "descricao": "Partes de veículos automóveis, tratores e máquinas autopropulsadas",
    "ncms": [
      "40161010"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0100900",
    "descricao": "Tapetes, revestimentos, mesmo confeccionados, batentes, buchas e coxins",
    "ncms": [
      "40169990",
      "57050000"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0101000",
    "descricao": "Tecidos impregnados, revestidos, recobertos ou estratificados, com plástico",
    "ncms": [
      "59039000"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0101100",
    "descricao": "Mangueiras e tubos semelhantes, de matérias têxteis, mesmo com reforço ou acessórios de outras matérias",
    "ncms": [
      "59090000"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0101200",
    "descricao": "Encerados e toldos",
    "ncms": [
      "63061"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0101300",
    "descricao": "Capacetes e artefatos de uso semelhante, de proteção, para uso em motocicletas, incluídos ciclomotores",
    "ncms": [
      "65061000"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0101400",
    "descricao": "Guarnições de fricção (por exemplo, placas, rolos, tiras, segmentos, discos, anéis, pastilhas), não montadas, para freios, embreagens ou qualquer outro mecanismo de fricção, à base de amianto, de outras substâncias minerais ou de celulose, mesmo combinadas com têxteis ou outras matérias",
    "ncms": [
      "6813"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0101500",
    "descricao": "Vidros de dimensões e formatos que permitam aplicação automotiva",
    "ncms": [
      "70071100",
      "70072100"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0101600",
    "descricao": "Espelhos retrovisores",
    "ncms": [
      "70091000"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0101700",
    "descricao": "Lentes de faróis, lanternas e outros utensílios",
    "ncms": [
      "70140000"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0101800",
    "descricao": "Cilindro de aço para GNV (gás natural veicular)",
    "ncms": [
      "73110000"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0101900",
    "descricao": "Recipientes para gases comprimidos ou liquefeitos, de ferro fundido, ferro ou aço, exceto o descrito no item 18.0",
    "ncms": [
      "73110000"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0102000",
    "descricao": "Molas e folhas de molas, de ferro ou aço",
    "ncms": [
      "7320"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0102100",
    "descricao": "Obras moldadas, de ferro fundido, ferro ou aço, exceto as do código 7325.91.00",
    "ncms": [
      "7325"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0102200",
    "descricao": "Peso de chumbo para balanceamento de roda",
    "ncms": [
      "780600"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0102300",
    "descricao": "Peso para balanceamento de roda e outros utensílios de estanho",
    "ncms": [
      "80070090"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0102400",
    "descricao": "Fechaduras e partes de fechaduras",
    "ncms": [
      "830120",
      "830160"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0102500",
    "descricao": "Chaves apresentadas isoladamente",
    "ncms": [
      "830170"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0102600",
    "descricao": "Dobradiças, guarnições, ferragens e artigos semelhantes de metais comuns",
    "ncms": [
      "83021000",
      "83023000"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0102700",
    "descricao": "Triângulo de segurança",
    "ncms": [
      "831000"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0102800",
    "descricao": "Motores de pistão alternativo dos tipos utilizados para propulsão de veículos do Capítulo 87",
    "ncms": [
      "84073"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0102900",
    "descricao": "Motores dos tipos utilizados para propulsão de veículos automotores",
    "ncms": [
      "840820"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0103000",
    "descricao": "Partes reconhecíveis como exclusiva ou principalmente destinadas aos motores das posições 8407 ou 8408",
    "ncms": [
      "84099"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0103100",
    "descricao": "Motores hidráulicos",
    "ncms": [
      "84122"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0103200",
    "descricao": "Bombas para combustíveis, lubrificantes ou líquidos de arrefecimento, próprias para motores de ignição por centelha ou por compressão",
    "ncms": [
      "841330"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0103300",
    "descricao": "Bombas de vácuo",
    "ncms": [
      "84141000"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0103400",
    "descricao": "Compressores e turbocompressores de ar",
    "ncms": [
      "8414801",
      "8414802"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0103500",
    "descricao": "Partes das bombas, compressores e turbocompressores dos CEST 01.032.00, 01.033.00 e 01.034.00",
    "ncms": [
      "84139190",
      "84149010",
      "8414903",
      "84149039"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0103600",
    "descricao": "Máquinas e aparelhos de ar condicionado",
    "ncms": [
      "841520"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0103700",
    "descricao": "Aparelhos para filtrar óleos minerais nos motores de ignição por centelha ou por compressão",
    "ncms": [
      "84212300"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0103800",
    "descricao": "Filtros a vácuo",
    "ncms": [
      "84212990"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0103900",
    "descricao": "Partes dos aparelhos para filtrar ou depurar líquidos ou gases",
    "ncms": [
      "84219"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0104000",
    "descricao": "Extintores, mesmo carregados",
    "ncms": [
      "84241000"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0104100",
    "descricao": "Filtros de entrada de ar para motores de ignição por centelha ou por compressão",
    "ncms": [
      "84213100"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0104200",
    "descricao": "Depuradores por conversão catalítica de gases de escape",
    "ncms": [
      "84213200"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0104300",
    "descricao": "Macacos",
    "ncms": [
      "84254200"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0104400",
    "descricao": "Partes para macacos do CEST 01.043.00",
    "ncms": [
      "84311010"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0104500",
    "descricao": "Partes reconhecíveis como exclusiva ou principalmente destinadas às máquinas agrícolas ou rodoviárias",
    "ncms": [
      "8431492"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0104501",
    "descricao": "Partes reconhecíveis como exclusiva ou principalmente destinadas às máquinas agrícolas ou rodoviárias",
    "ncms": [
      "84339090"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0104600",
    "descricao": "Válvulas redutoras de pressão",
    "ncms": [
      "84811000"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0104700",
    "descricao": "Válvulas para transmissão óleo-hidráulicas ou pneumáticas",
    "ncms": [
      "84812"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0104800",
    "descricao": "Válvulas solenoides",
    "ncms": [
      "84818092"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0104900",
    "descricao": "Rolamentos",
    "ncms": [
      "8482"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0105000",
    "descricao": "Árvores de transmissão (incluídas as árvores de “cames” e virabrequins) e manivelas; mancais e “bronzes”; engrenagens e rodas de fricção; eixos de esferas ou de roletes; redutores, multiplicadores, caixas de transmissão e variadores de velocidade, incluídos os conversores de torque; volantes e polias, incluídas as polias para cadernais; embreagens e dispositivos de acoplamento, incluídas as juntas de articulação",
    "ncms": [
      "8483"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0105100",
    "descricao": "Juntas metaloplásticas; jogos ou sortidos de juntas de composições diferentes, apresentados em bolsas, envelopes ou embalagens semelhantes; juntas de vedação mecânicas (selos mecânicos)",
    "ncms": [
      "8484"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0105200",
    "descricao": "Acoplamentos, embreagens, variadores de velocidade e freios, eletromagnéticos",
    "ncms": [
      "850520"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0105300",
    "descricao": "Acumuladores elétricos de chumbo, do tipo utilizado para o arranque dos motores de pistão, exceto os classificados no CEST 01.053.01",
    "ncms": [
      "850710"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0105301",
    "descricao": "Acumuladores elétricos de chumbo, do tipo utilizado para o arranque dos motores de pistão e de capacidade inferior ou igual a 20 Ah e tensão inferior ou igual a 12 V",
    "ncms": [
      "85071010"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0105400",
    "descricao": "Aparelhos e dispositivos elétricos de ignição ou de arranque para motores de ignição por centelha ou por compressão (por exemplo, magnetos, dínamos-magnetos, bobinas de ignição, velas de ignição ou de aquecimento, motores de arranque); geradores (dínamos e alternadores, por exemplo) e conjuntores-disjuntores utilizados com estes motores",
    "ncms": [
      "8511"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0105500",
    "descricao": "Aparelhos elétricos de iluminação ou de sinalização (exceto os da posição 8539), limpadores de para-brisas, degeladores e desembaçadores (desembaciadores) elétricos e suas partes",
    "ncms": [
      "851220",
      "851240",
      "85129000"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0105600",
    "descricao": "Telefones móveis do tipo dos utilizados em veículos automóveis",
    "ncms": [
      "85171410"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0105700",
    "descricao": "Alto-falantes, amplificadores elétricos de audiofrequência e partes",
    "ncms": [
      "8518"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0105800",
    "descricao": "Aparelhos elétricos de amplificação de som para veículos automotores",
    "ncms": [
      "85185000"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0105900",
    "descricao": "Aparelhos de reprodução de som",
    "ncms": [
      "851981"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0106000",
    "descricao": "Aparelhos transmissores (emissores) de radiotelefonia ou radiotelegrafia (rádio receptor/transmissor)",
    "ncms": [
      "8525501",
      "85256010"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0106100",
    "descricao": "Aparelhos receptores de radiodifusão que só funcionem com fonte externa de energia combinados com um aparelho de gravação ou de reprodução de som, do tipo utilizado em veículos automóveis",
    "ncms": [
      "85272100"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0106200",
    "descricao": "Outros aparelhos receptores de radiodifusão que só funcionem com fonte externa de energia, do tipo utilizado em veículos automóveis",
    "ncms": [
      "85272900"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0106201",
    "descricao": "Outros aparelhos videofônicos de gravação ou de reprodução, mesmo incorporando um receptor de sinais videofônicos, dos tipos utilizados exclusivamente em veículos automotores",
    "ncms": [
      "85219090"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0106400",
    "descricao": "Circuitos impressos",
    "ncms": [
      "853400"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0106500",
    "descricao": "Interruptores e seccionadores e comutadores",
    "ncms": [
      "853530",
      "853650"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0106600",
    "descricao": "Fusíveis e corta-circuitos de fusíveis",
    "ncms": [
      "85361000"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0106700",
    "descricao": "Disjuntores",
    "ncms": [
      "85362000"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0106800",
    "descricao": "Relés",
    "ncms": [
      "85364"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0106900",
    "descricao": "Partes reconhecíveis como exclusivas ou principalmente destinados aos aparelhos dos CEST 01.065.00, 01.066.00, 01.067.00 e 01.068.00",
    "ncms": [
      "8538"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0107000",
    "descricao": "Faróis e projetores, em unidades seladas",
    "ncms": [
      "853910"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0107100",
    "descricao": "Lâmpadas e tubos de incandescência, exceto de raios ultravioleta ou infravermelhos",
    "ncms": [
      "85392"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0107200",
    "descricao": "Cabos coaxiais e outros condutores elétricos coaxiais",
    "ncms": [
      "85442000"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0107300",
    "descricao": "Jogos de fios para velas de ignição e outros jogos de fios",
    "ncms": [
      "85443000"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0107400",
    "descricao": "Carroçarias para os veículos automóveis das posições 8701 a 8705, incluídas as cabinas",
    "ncms": [
      "8707"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0107500",
    "descricao": "Partes e acessórios dos veículos automóveis das posições 8701 a 8705",
    "ncms": [
      "8708"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0107600",
    "descricao": "Parte e acessórios de motocicletas (incluídos os ciclomotores)",
    "ncms": [
      "87141"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0107700",
    "descricao": "Engates para reboques e semirreboques",
    "ncms": [
      "87169090"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0107800",
    "descricao": "Medidores de nível; Medidores de vazão",
    "ncms": [
      "902610"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0107900",
    "descricao": "Aparelhos para medida ou controle da pressão",
    "ncms": [
      "902620"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0108000",
    "descricao": "Contadores, indicadores de velocidade e tacômetros, suas partes e acessórios",
    "ncms": [
      "9029"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0108100",
    "descricao": "Amperímetros",
    "ncms": [
      "90303321"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0108200",
    "descricao": "Aparelhos digitais, de uso em veículos automóveis, para medida e indicação de múltiplas grandezas tais como: velocidade média, consumos instantâneo e médio e autonomia (computador de bordo)",
    "ncms": [
      "90318040"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0108300",
    "descricao": "Controladores eletrônicos",
    "ncms": [
      "9032892"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0108400",
    "descricao": "Relógios para painéis de instrumentos e relógios semelhantes",
    "ncms": [
      "91040000"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0108600",
    "descricao": "Acendedores",
    "ncms": [
      "96138000"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0108700",
    "descricao": "Tubos de borracha vulcanizada não endurecida, mesmo providos de seus acessórios",
    "ncms": [
      "4009"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0108800",
    "descricao": "Juntas de vedação de cortiça natural e de amianto",
    "ncms": [
      "45049000",
      "68129910"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0108900",
    "descricao": "Papel-diagrama para tacógrafo, em disco",
    "ncms": [
      "48234000"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0109000",
    "descricao": "Fitas, tiras, adesivos, autocolantes, de plástico, refletores, mesmo em rolos; placas metálicas com película de plástico refletora, próprias para colocação em carrocerias, para-choques de veículos de carga, motocicletas, ciclomotores, capacetes, bonés de agentes de trânsito e de condutores de veículos, atuando como dispositivos refletivos de segurança rodoviários",
    "ncms": [
      "391910"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0109100",
    "descricao": "Cilindros pneumáticos",
    "ncms": [
      "84123110"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0109200",
    "descricao": "Bomba elétrica de lavador de para-brisa",
    "ncms": [
      "84131900",
      "84135090",
      "84138100"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0109300",
    "descricao": "Bomba de assistência de direção hidráulica",
    "ncms": [
      "84136019",
      "84137010"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0109400",
    "descricao": "Motoventiladores",
    "ncms": [
      "84145910",
      "84145990"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0109500",
    "descricao": "Filtros de pólen do ar-condicionado",
    "ncms": [
      "84213990"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0109600",
    "descricao": "“Máquina” de vidro elétrico de porta",
    "ncms": [
      "85011019"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0109700",
    "descricao": "Motor de limpador de para-brisa",
    "ncms": [
      "85013110"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0109800",
    "descricao": "Bobinas de reatância e de autoindução",
    "ncms": [
      "85045000"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0109900",
    "descricao": "Baterias de chumbo e de níquel-cádmio",
    "ncms": [
      "850720",
      "850730"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0110000",
    "descricao": "Aparelhos de sinalização acústica (buzina)",
    "ncms": [
      "85123000"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0110100",
    "descricao": "Instrumentos para regulação de grandezas não elétricas",
    "ncms": [
      "9032898",
      "9032899"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0110200",
    "descricao": "Analisadores de gases ou de fumaça (sonda lambda)",
    "ncms": [
      "90271000"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0110300",
    "descricao": "Perfilados de borracha vulcanizada não endurecida",
    "ncms": [
      "40081100"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0110400",
    "descricao": "Artefatos de pasta de fibra de uso automotivo",
    "ncms": [
      "56012219"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0110500",
    "descricao": "Tapetes/carpetes – náilon",
    "ncms": [
      "57032900"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0110600",
    "descricao": "Tapetes de matérias têxteis sintéticas",
    "ncms": [
      "57033900"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0110700",
    "descricao": "Forração interior capacete",
    "ncms": [
      "59119000"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0110800",
    "descricao": "Outros para-brisas",
    "ncms": [
      "69039099"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0110900",
    "descricao": "Moldura com espelho",
    "ncms": [
      "70072900"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0111000",
    "descricao": "REVOGADO",
    "ncms": [
      "73145000"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0111100",
    "descricao": "Corrente transmissão",
    "ncms": [
      "73151100"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0111200",
    "descricao": "Outras correntes de transmissão",
    "ncms": [
      "73151210"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0111300",
    "descricao": "Condensador tubular metálico",
    "ncms": [
      "84189900"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0111400",
    "descricao": "Trocadores de calor",
    "ncms": [
      "841950"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0111500",
    "descricao": "Partes de aparelhos mecânicos de pulverizar ou dispersar",
    "ncms": [
      "84249090"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0111600",
    "descricao": "Macacos manuais para veículos",
    "ncms": [
      "84254910"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0111700",
    "descricao": "Caçambas, pás, ganchos e tenazes para máquinas rodoviárias",
    "ncms": [
      "84314100"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0111800",
    "descricao": "Geradores de corrente alternada de potência não superior a 75 kva",
    "ncms": [
      "85016100"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0111900",
    "descricao": "Aparelhos elétricos para alarme de uso automotivo",
    "ncms": [
      "85311090"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0112000",
    "descricao": "Bússolas",
    "ncms": [
      "90141000"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0112100",
    "descricao": "Indicadores de temperatura",
    "ncms": [
      "90251990"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0112200",
    "descricao": "Partes de indicadores de temperatura",
    "ncms": [
      "90259010"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0112300",
    "descricao": "Partes de aparelhos de medida ou controle",
    "ncms": [
      "902690"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0112400",
    "descricao": "Termostatos",
    "ncms": [
      "90321010"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0112500",
    "descricao": "Instrumentos e aparelhos para regulação",
    "ncms": [
      "90321090"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0112600",
    "descricao": "Pressostatos",
    "ncms": [
      "90322000"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0112700",
    "descricao": "Peças para reboques e semirreboques, exceto os itens classificados no CEST 01.077.00",
    "ncms": [
      "871690"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0112800",
    "descricao": "Geradores de ar quente a combustível líquido, com capacidade superior ou igual a 1.500 kcal/h, mas inferior ou igual a 10.400 kcal/h, do tipo dos utilizados em veículos automóveis",
    "ncms": [
      "73229010"
    ],
    "segmento": "AUTOPEÇAS"
  },
  {
    "codigo": "0200100",
    "descricao": "Aperitivos, amargos, bitter e similares",
    "ncms": [
      "2205"
    ],
    "segmento": "BEBIDAS ALCOÓLICAS, EXCETO CERVEJA E CHOPE"
  },
  {
    "codigo": "0200200",
    "descricao": "Batida e similares",
    "ncms": [
      "22089000"
    ],
    "segmento": "BEBIDAS ALCOÓLICAS, EXCETO CERVEJA E CHOPE"
  },
  {
    "codigo": "0200300",
    "descricao": "Bebida ice",
    "ncms": [
      "22089000"
    ],
    "segmento": "BEBIDAS ALCOÓLICAS, EXCETO CERVEJA E CHOPE"
  },
  {
    "codigo": "0200400",
    "descricao": "Cachaça e aguardentes",
    "ncms": [
      "220720"
    ],
    "segmento": "BEBIDAS ALCOÓLICAS, EXCETO CERVEJA E CHOPE"
  },
  {
    "codigo": "0200500",
    "descricao": "Catuaba e similares",
    "ncms": [
      "2205"
    ],
    "segmento": "BEBIDAS ALCOÓLICAS, EXCETO CERVEJA E CHOPE"
  },
  {
    "codigo": "0200600",
    "descricao": "Conhaque, brandy e similares",
    "ncms": [
      "22082000"
    ],
    "segmento": "BEBIDAS ALCOÓLICAS, EXCETO CERVEJA E CHOPE"
  },
  {
    "codigo": "0200700",
    "descricao": "Cooler",
    "ncms": [
      "22060090"
    ],
    "segmento": "BEBIDAS ALCOÓLICAS, EXCETO CERVEJA E CHOPE"
  },
  {
    "codigo": "0200800",
    "descricao": "Gim (gin) e genebra",
    "ncms": [
      "22085000"
    ],
    "segmento": "BEBIDAS ALCOÓLICAS, EXCETO CERVEJA E CHOPE"
  },
  {
    "codigo": "0200900",
    "descricao": "Jurubeba e similares",
    "ncms": [
      "2205"
    ],
    "segmento": "BEBIDAS ALCOÓLICAS, EXCETO CERVEJA E CHOPE"
  },
  {
    "codigo": "0201000",
    "descricao": "Licores e similares",
    "ncms": [
      "22087000"
    ],
    "segmento": "BEBIDAS ALCOÓLICAS, EXCETO CERVEJA E CHOPE"
  },
  {
    "codigo": "0201100",
    "descricao": "Pisco",
    "ncms": [
      "22082000"
    ],
    "segmento": "BEBIDAS ALCOÓLICAS, EXCETO CERVEJA E CHOPE"
  },
  {
    "codigo": "0201200",
    "descricao": "Rum",
    "ncms": [
      "22084000"
    ],
    "segmento": "BEBIDAS ALCOÓLICAS, EXCETO CERVEJA E CHOPE"
  },
  {
    "codigo": "0201300",
    "descricao": "Saquê",
    "ncms": [
      "22060090"
    ],
    "segmento": "BEBIDAS ALCOÓLICAS, EXCETO CERVEJA E CHOPE"
  },
  {
    "codigo": "0201400",
    "descricao": "Steinhaeger",
    "ncms": [
      "22089000"
    ],
    "segmento": "BEBIDAS ALCOÓLICAS, EXCETO CERVEJA E CHOPE"
  },
  {
    "codigo": "0201500",
    "descricao": "Tequila",
    "ncms": [
      "22089000"
    ],
    "segmento": "BEBIDAS ALCOÓLICAS, EXCETO CERVEJA E CHOPE"
  },
  {
    "codigo": "0201600",
    "descricao": "Uísque",
    "ncms": [
      "220830"
    ],
    "segmento": "BEBIDAS ALCOÓLICAS, EXCETO CERVEJA E CHOPE"
  },
  {
    "codigo": "0201700",
    "descricao": "Vermute e similares",
    "ncms": [
      "2205"
    ],
    "segmento": "BEBIDAS ALCOÓLICAS, EXCETO CERVEJA E CHOPE"
  },
  {
    "codigo": "0201800",
    "descricao": "Vodka",
    "ncms": [
      "22086000"
    ],
    "segmento": "BEBIDAS ALCOÓLICAS, EXCETO CERVEJA E CHOPE"
  },
  {
    "codigo": "0201900",
    "descricao": "Derivados de vodka",
    "ncms": [
      "22089000"
    ],
    "segmento": "BEBIDAS ALCOÓLICAS, EXCETO CERVEJA E CHOPE"
  },
  {
    "codigo": "0202000",
    "descricao": "Arak",
    "ncms": [
      "22089000"
    ],
    "segmento": "BEBIDAS ALCOÓLICAS, EXCETO CERVEJA E CHOPE"
  },
  {
    "codigo": "0202100",
    "descricao": "Aguardente vínica / grappa",
    "ncms": [
      "22082000"
    ],
    "segmento": "BEBIDAS ALCOÓLICAS, EXCETO CERVEJA E CHOPE"
  },
  {
    "codigo": "0202200",
    "descricao": "Sidra e similares",
    "ncms": [
      "22060010"
    ],
    "segmento": "BEBIDAS ALCOÓLICAS, EXCETO CERVEJA E CHOPE"
  },
  {
    "codigo": "0202300",
    "descricao": "Sangrias e coquetéis",
    "ncms": [
      "2205"
    ],
    "segmento": "BEBIDAS ALCOÓLICAS, EXCETO CERVEJA E CHOPE"
  },
  {
    "codigo": "0202400",
    "descricao": "Vinhos de uvas frescas, incluindo os vinhos enriquecidos com álcool; mostos de uvas.",
    "ncms": [
      "2204"
    ],
    "segmento": "BEBIDAS ALCOÓLICAS, EXCETO CERVEJA E CHOPE"
  },
  {
    "codigo": "0299900",
    "descricao": "Outras bebidas alcoólicas não especificadas nos itens anteriores",
    "ncms": [
      "2205"
    ],
    "segmento": "BEBIDAS ALCOÓLICAS, EXCETO CERVEJA E CHOPE"
  },
  {
    "codigo": "0300100",
    "descricao": "REVOGADO",
    "ncms": [
      "22011000"
    ],
    "segmento": "CERVEJAS, CHOPES, REFRIGERANTES, ÁGUAS E OUTRAS BEBIDAS"
  },
  {
    "codigo": "0300200",
    "descricao": "REVOGADO",
    "ncms": [
      "22011000"
    ],
    "segmento": "CERVEJAS, CHOPES, REFRIGERANTES, ÁGUAS E OUTRAS BEBIDAS"
  },
  {
    "codigo": "0300400",
    "descricao": "REVOGADO",
    "ncms": [
      "22011000"
    ],
    "segmento": "CERVEJAS, CHOPES, REFRIGERANTES, ÁGUAS E OUTRAS BEBIDAS"
  },
  {
    "codigo": "0300600",
    "descricao": "Outras águas minerais, gasosa ou não, ou potável, naturais; exceto as classificadas no CEST 03.003.00, 03.003.01, 03.005.00, 03.005.01 a 03.005.05, 03.024.00 e 03.025.00",
    "ncms": [
      "2201",
      "22011000"
    ],
    "segmento": "CERVEJAS, CHOPES, REFRIGERANTES, ÁGUAS E OUTRAS BEBIDAS"
  },
  {
    "codigo": "0300700",
    "descricao": "Água aromatizada artificialmente, exceto os refrescos e refrigerantes",
    "ncms": [
      "22021000"
    ],
    "segmento": "CERVEJAS, CHOPES, REFRIGERANTES, ÁGUAS E OUTRAS BEBIDAS"
  },
  {
    "codigo": "0300800",
    "descricao": "Outras águas minerais, gasosa ou não, ou potável, naturais, inclusive gaseificadas ou aromatizadas artificialmente, exceto os refrescos e refrigerantes",
    "ncms": [
      "22029900"
    ],
    "segmento": "CERVEJAS, CHOPES, REFRIGERANTES, ÁGUAS E OUTRAS BEBIDAS"
  },
  {
    "codigo": "0301000",
    "descricao": "Refrigerante em vidro descartável",
    "ncms": [
      "22021000",
      "2202"
    ],
    "segmento": "CERVEJAS, CHOPES, REFRIGERANTES, ÁGUAS E OUTRAS BEBIDAS"
  },
  {
    "codigo": "0301001",
    "descricao": "Refrigerante em embalagem pet",
    "ncms": [
      "22021000"
    ],
    "segmento": "CERVEJAS, CHOPES, REFRIGERANTES, ÁGUAS E OUTRAS BEBIDAS"
  },
  {
    "codigo": "0301002",
    "descricao": "Refrigerante em lata",
    "ncms": [
      "22021000"
    ],
    "segmento": "CERVEJAS, CHOPES, REFRIGERANTES, ÁGUAS E OUTRAS BEBIDAS"
  },
  {
    "codigo": "0301003",
    "descricao": "REVOGADO",
    "ncms": [
      "22021000"
    ],
    "segmento": "CERVEJAS, CHOPES, REFRIGERANTES, ÁGUAS E OUTRAS BEBIDAS"
  },
  {
    "codigo": "0301100",
    "descricao": "Demais refrigerantes, exceto os classificados no CEST 03.010.00, 03.010.01, 03.010.02 e 03.011.01",
    "ncms": [
      "22021000"
    ],
    "segmento": "CERVEJAS, CHOPES, REFRIGERANTES, ÁGUAS E OUTRAS BEBIDAS"
  },
  {
    "codigo": "0301101",
    "descricao": "Espumantes sem álcool",
    "ncms": [
      "2202"
    ],
    "segmento": "CERVEJAS, CHOPES, REFRIGERANTES, ÁGUAS E OUTRAS BEBIDAS"
  },
  {
    "codigo": "0301200",
    "descricao": "Xarope ou extrato concentrado destinados ao preparo de refrigerante em máquina “pré-mix” ou “post-mix”, exceto o classificado no CEST 03.012.01",
    "ncms": [
      "21069010"
    ],
    "segmento": "CERVEJAS, CHOPES, REFRIGERANTES, ÁGUAS E OUTRAS BEBIDAS"
  },
  {
    "codigo": "0301201",
    "descricao": "Cápsula de refrigerante",
    "ncms": [
      "21069010"
    ],
    "segmento": "CERVEJAS, CHOPES, REFRIGERANTES, ÁGUAS E OUTRAS BEBIDAS"
  },
  {
    "codigo": "0301301",
    "descricao": "Bebidas energéticas em embalagem PET",
    "ncms": [
      "210690"
    ],
    "segmento": "CERVEJAS, CHOPES, REFRIGERANTES, ÁGUAS E OUTRAS BEBIDAS"
  },
  {
    "codigo": "0301302",
    "descricao": "Bebidas energéticas em vidro",
    "ncms": [
      "210690"
    ],
    "segmento": "CERVEJAS, CHOPES, REFRIGERANTES, ÁGUAS E OUTRAS BEBIDAS"
  },
  {
    "codigo": "0301400",
    "descricao": "REVOGADO",
    "ncms": [
      "210690"
    ],
    "segmento": "CERVEJAS, CHOPES, REFRIGERANTES, ÁGUAS E OUTRAS BEBIDAS"
  },
  {
    "codigo": "0301600",
    "descricao": "REVOGADO",
    "ncms": [
      "210690"
    ],
    "segmento": "CERVEJAS, CHOPES, REFRIGERANTES, ÁGUAS E OUTRAS BEBIDAS"
  },
  {
    "codigo": "0302100",
    "descricao": "Cerveja em garrafa de vidro retornável",
    "ncms": [
      "22030000"
    ],
    "segmento": "CERVEJAS, CHOPES, REFRIGERANTES, ÁGUAS E OUTRAS BEBIDAS"
  },
  {
    "codigo": "0302101",
    "descricao": "Cerveja em garrafa de vidro descartável",
    "ncms": [
      "22030000"
    ],
    "segmento": "CERVEJAS, CHOPES, REFRIGERANTES, ÁGUAS E OUTRAS BEBIDAS"
  },
  {
    "codigo": "0302102",
    "descricao": "Cerveja em garrafa de alumínio",
    "ncms": [
      "22030000"
    ],
    "segmento": "CERVEJAS, CHOPES, REFRIGERANTES, ÁGUAS E OUTRAS BEBIDAS"
  },
  {
    "codigo": "0302103",
    "descricao": "Cerveja em lata",
    "ncms": [
      "22030000"
    ],
    "segmento": "CERVEJAS, CHOPES, REFRIGERANTES, ÁGUAS E OUTRAS BEBIDAS"
  },
  {
    "codigo": "0302104",
    "descricao": "Cerveja em barril",
    "ncms": [
      "22030000"
    ],
    "segmento": "CERVEJAS, CHOPES, REFRIGERANTES, ÁGUAS E OUTRAS BEBIDAS"
  },
  {
    "codigo": "0302105",
    "descricao": "Cerveja em embalagem PET",
    "ncms": [
      "22030000"
    ],
    "segmento": "CERVEJAS, CHOPES, REFRIGERANTES, ÁGUAS E OUTRAS BEBIDAS"
  },
  {
    "codigo": "0302106",
    "descricao": "Cerveja em outras embalagens",
    "ncms": [
      "22030000"
    ],
    "segmento": "CERVEJAS, CHOPES, REFRIGERANTES, ÁGUAS E OUTRAS BEBIDAS"
  },
  {
    "codigo": "0302200",
    "descricao": "Cerveja sem álcool em garrafa de vidro retornável",
    "ncms": [
      "22029100"
    ],
    "segmento": "CERVEJAS, CHOPES, REFRIGERANTES, ÁGUAS E OUTRAS BEBIDAS"
  },
  {
    "codigo": "0302201",
    "descricao": "Cerveja sem álcool em garrafa de vidro descartável",
    "ncms": [
      "22029100"
    ],
    "segmento": "CERVEJAS, CHOPES, REFRIGERANTES, ÁGUAS E OUTRAS BEBIDAS"
  },
  {
    "codigo": "0302202",
    "descricao": "Cerveja sem álcool em garrafa de alumínio",
    "ncms": [
      "22029100"
    ],
    "segmento": "CERVEJAS, CHOPES, REFRIGERANTES, ÁGUAS E OUTRAS BEBIDAS"
  },
  {
    "codigo": "0302203",
    "descricao": "Cerveja sem álcool em lata",
    "ncms": [
      "22029100"
    ],
    "segmento": "CERVEJAS, CHOPES, REFRIGERANTES, ÁGUAS E OUTRAS BEBIDAS"
  },
  {
    "codigo": "0302204",
    "descricao": "Cerveja sem álcool em barril",
    "ncms": [
      "22029100"
    ],
    "segmento": "CERVEJAS, CHOPES, REFRIGERANTES, ÁGUAS E OUTRAS BEBIDAS"
  },
  {
    "codigo": "0302205",
    "descricao": "Cerveja sem álcool em embalagem PET",
    "ncms": [
      "22029100"
    ],
    "segmento": "CERVEJAS, CHOPES, REFRIGERANTES, ÁGUAS E OUTRAS BEBIDAS"
  },
  {
    "codigo": "0302206",
    "descricao": "Cerveja sem álcool em outras embalagens",
    "ncms": [
      "22029100"
    ],
    "segmento": "CERVEJAS, CHOPES, REFRIGERANTES, ÁGUAS E OUTRAS BEBIDAS"
  },
  {
    "codigo": "0302300",
    "descricao": "Chope",
    "ncms": [
      "22030000"
    ],
    "segmento": "CERVEJAS, CHOPES, REFRIGERANTES, ÁGUAS E OUTRAS BEBIDAS"
  },
  {
    "codigo": "0302400",
    "descricao": "Água mineral em embalagens retornáveis com capacidade igual ou superior a 10 (dez) e inferior a 20 (vinte) litros",
    "ncms": [
      "22011000"
    ],
    "segmento": "CERVEJAS, CHOPES, REFRIGERANTES, ÁGUAS E OUTRAS BEBIDAS"
  },
  {
    "codigo": "0302500",
    "descricao": "Água mineral em embalagens retornáveis com capacidade igual ou superior a 20 (vinte) litros",
    "ncms": [
      "22011000"
    ],
    "segmento": "CERVEJAS, CHOPES, REFRIGERANTES, ÁGUAS E OUTRAS BEBIDAS"
  },
  {
    "codigo": "0400100",
    "descricao": "Charutos, cigarrilhas e cigarros, de tabaco ou dos seus sucedâneos",
    "ncms": [
      "2402"
    ],
    "segmento": "CIGARROS E OUTROS PRODUTOS DERIVADOS DO FUMO"
  },
  {
    "codigo": "0400200",
    "descricao": "Tabaco para fumar, mesmo contendo sucedâneos de tabaco em qualquer proporção",
    "ncms": [
      "24031"
    ],
    "segmento": "CIGARROS E OUTROS PRODUTOS DERIVADOS DO FUMO"
  },
  {
    "codigo": "0500100",
    "descricao": "Cimento",
    "ncms": [
      "2523"
    ],
    "segmento": "CIMENTOS"
  },
  {
    "codigo": "0600100",
    "descricao": "Álcool etílico não desnaturado, com um teor alcoólico em volume igual ou superior a 80% vol - Com um teor de água igual ou inferior a 1 % vol (álcool etílico anidro combustível)",
    "ncms": [
      "22071010"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0600101",
    "descricao": "Álcool etílico não desnaturado, com um teor alcoólico em volume igual ou superior a 80% vol - Outros (álcool etílico hidratado combustível)",
    "ncms": [
      "22071090"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0600200",
    "descricao": "Gasolina automotiva A, exceto Premium",
    "ncms": [
      "27101259"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0600201",
    "descricao": "Gasolina automotiva C, exceto Premium",
    "ncms": [
      "27101259"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0600202",
    "descricao": "Gasolina automotiva A Premium",
    "ncms": [
      "27101259"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0600203",
    "descricao": "Gasolina automotiva C Premium",
    "ncms": [
      "27101259"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0600300",
    "descricao": "Gasolina de aviação",
    "ncms": [
      "27101251"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0600400",
    "descricao": "Querosenes, exceto de aviação",
    "ncms": [
      "27101919"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0600500",
    "descricao": "Querosene de aviação",
    "ncms": [
      "27101911"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0600600",
    "descricao": "Óleo diesel A, exceto S10 e Marítimo",
    "ncms": [
      "2710192"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0600601",
    "descricao": "Óleo diesel B, exceto S10 (mistura obrigatória)",
    "ncms": [
      "2710192"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0600602",
    "descricao": "Óleo diesel B, exceto S10 (misturas autorizativas)",
    "ncms": [
      "2710192"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0600603",
    "descricao": "Óleo diesel B, exceto S10 (misturas experimentais)",
    "ncms": [
      "2710192"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0600604",
    "descricao": "Óleo diesel A S10",
    "ncms": [
      "2710192"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0600605",
    "descricao": "Óleo diesel B S10 (mistura obrigatória)",
    "ncms": [
      "2710192"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0600606",
    "descricao": "Óleo diesel B S10 (misturas autorizativas)",
    "ncms": [
      "2710192"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0600607",
    "descricao": "Óleo diesel B S10 (misturas experimentais)",
    "ncms": [
      "2710192"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0600608",
    "descricao": "Óleo Diesel Marítimo",
    "ncms": [
      "2710192"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0600609",
    "descricao": "Outros óleos combustíveis, exceto os classificados no CEST 06.006.10 e 06.006.11",
    "ncms": [
      "2710192"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0600610",
    "descricao": "Óleo combustível derivado de xisto",
    "ncms": [
      "2710192"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0600611",
    "descricao": "Óleo combustível pesado",
    "ncms": [
      "27101922"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0600700",
    "descricao": "Óleos lubrificantes",
    "ncms": [
      "2710193"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0600800",
    "descricao": "Outros óleos de petróleo ou de minerais betuminosos (exceto óleos brutos) e preparações não especificadas nem compreendidas noutras posições, que contenham, como constituintes básicos, 70% ou mais, em peso, de óleos de petróleo ou de minerais betuminosos, exceto os que contenham biodiesel, exceto os resíduos de óleos e exceto as graxas lubrificantes",
    "ncms": [
      "2710199"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0600801",
    "descricao": "Graxa lubrificante",
    "ncms": [
      "2710199"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0600900",
    "descricao": "Resíduos de óleos",
    "ncms": [
      "27109"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0601000",
    "descricao": "Gás de petróleo e outros hidrocarbonetos gasosos, exceto GLP, GLGN, Gás Natural e Gás de xisto.",
    "ncms": [
      "2711"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0601100",
    "descricao": "Gás liquefeito de petróleo em botijão de 13 Kg (GLP)",
    "ncms": [
      "27111910"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0601101",
    "descricao": "Gás liquefeito de petróleo (GLP), exceto em botijão de 13 Kg",
    "ncms": [
      "27111910"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0601102",
    "descricao": "Gás liquefeito de petróleo em botijão de 13 Kg (GLGNn)",
    "ncms": [
      "27111910"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0601103",
    "descricao": "Gás liquefeito de petróleo (GLGNn), exceto em botijão de 13 Kg",
    "ncms": [
      "27111910"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0601104",
    "descricao": "Gás liquefeito de petróleo em botijão de 13 Kg (GLGNi)",
    "ncms": [
      "27111910"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0601105",
    "descricao": "Gás liquefeito de petróleo (GLGNi), exceto em botijão de 13 Kg",
    "ncms": [
      "27111910"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0601106",
    "descricao": "Gás liquefeito de petróleo em botijão de 13 kg (Misturas)",
    "ncms": [
      "27111910"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0601107",
    "descricao": "Gás liquefeito de petróleo (Misturas), exceto em botijão de 13 Kg",
    "ncms": [
      "27111910"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0601200",
    "descricao": "Gás Natural Liquefeito",
    "ncms": [
      "27111100"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0601300",
    "descricao": "Gás Natural Gasoso",
    "ncms": [
      "27112100"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0601400",
    "descricao": "Gás de xisto",
    "ncms": [
      "27112990"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0601500",
    "descricao": "Coque de petróleo e outros resíduos de óleo de petróleo ou de minerais betuminosos",
    "ncms": [
      "2713"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0601600",
    "descricao": "Biodiesel e suas misturas, que não contenham ou que contenham menos de 70%, em peso, de óleos de petróleo ou de óleos minerais betuminosos",
    "ncms": [
      "38260000"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0601700",
    "descricao": "Preparações lubrificantes, exceto as contendo, como constituintes de base, 70% ou mais, em peso, de óleos de petróleo ou de minerais betuminosos",
    "ncms": [
      "3403"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0601800",
    "descricao": "Óleos de petróleo ou de minerais betuminosos (exceto óleos brutos) e preparações não especificadas nem compreendidas noutras posições, que contenham, como constituintes básicos, 70% ou mais, em peso, de óleos de petróleo ou de minerais betuminosos, que contenham biodiesel, exceto os resíduos de óleos",
    "ncms": [
      "27102000"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0601900",
    "descricao": "Naftas, exceto a Nafta petroquímica.",
    "ncms": [
      "2710"
    ],
    "segmento": "COMBUSTÍVEIS E LUBRIFICANTES"
  },
  {
    "codigo": "0700100",
    "descricao": "Energia elétrica",
    "ncms": [
      "27160000"
    ],
    "segmento": "ENERGIA ELÉTRICA"
  },
  {
    "codigo": "0800100",
    "descricao": "Ferramentas de borracha vulcanizada não endurecida",
    "ncms": [
      "40169990"
    ],
    "segmento": "FERRAMENTAS"
  },
  {
    "codigo": "0800200",
    "descricao": "Ferramentas, armações e cabos de ferramentas, de madeira",
    "ncms": [
      "44170010",
      "44170090"
    ],
    "segmento": "FERRAMENTAS"
  },
  {
    "codigo": "0800300",
    "descricao": "Mós e artefatos semelhantes, sem armação, para moer, desfibrar, triturar, amolar, polir, retificar ou cortar; pedras para amolar ou para polir, manualmente, e suas partes, de pedras naturais, de abrasivos naturais ou artificiais aglomerados ou de cerâmica, mesmo com partes de outras matérias",
    "ncms": [
      "6804"
    ],
    "segmento": "FERRAMENTAS"
  },
  {
    "codigo": "0800400",
    "descricao": "Pás, alviões, picaretas, enxadas, sachos, forcados e forquilhas, ancinhos e raspadeiras; machados, podões e ferramentas semelhantes com gume; tesouras de podar de todos os tipos; foices e foicinhas, facas para feno ou para palha, tesouras para sebes, cunhas e outras ferramentas manuais para agricultura, horticultura ou silvicultura",
    "ncms": [
      "8201"
    ],
    "segmento": "FERRAMENTAS"
  },
  {
    "codigo": "0800500",
    "descricao": "Folhas de serras de fita",
    "ncms": [
      "82022000"
    ],
    "segmento": "FERRAMENTAS"
  },
  {
    "codigo": "0800600",
    "descricao": "Lâminas de serras máquinas",
    "ncms": [
      "82029100"
    ],
    "segmento": "FERRAMENTAS"
  },
  {
    "codigo": "0800700",
    "descricao": "Serras manuais e outras folhas de serras (incluídas as fresas-serras e as folhas não dentadas para serrar), exceto as classificadas nos CEST 08.005.00 e 08.006.00",
    "ncms": [
      "8202"
    ],
    "segmento": "FERRAMENTAS"
  },
  {
    "codigo": "0800800",
    "descricao": "Limas, grosas, alicates (mesmo cortantes), tenazes, pinças, cisalhas para metais, corta-tubos, corta-pinos, saca-bocados e ferramentas semelhantes, manuais, exceto as pinças para sobrancelhas classificadas na posição 8203.20.90",
    "ncms": [
      "8203"
    ],
    "segmento": "FERRAMENTAS"
  },
  {
    "codigo": "0800900",
    "descricao": "Chaves de porcas, manuais (incluídas as chaves dinamométricas); chaves de caixa intercambiáveis, mesmo com cabos",
    "ncms": [
      "8204"
    ],
    "segmento": "FERRAMENTAS"
  },
  {
    "codigo": "0801000",
    "descricao": "Ferramentas manuais (incluídos os diamantes de vidraceiro) não especificadas nem compreendidas em outras posições, lamparinas ou lâmpadas de soldar (maçaricos) e semelhantes; tornos de apertar, sargentos e semelhantes, exceto os acessórios ou partes de máquinas-ferramentas; bigornas; forjas-portáteis; mós com armação, manuais ou de pedal",
    "ncms": [
      "8205"
    ],
    "segmento": "FERRAMENTAS"
  },
  {
    "codigo": "0801100",
    "descricao": "Ferramentas de pelo menos duas das posições 8202 a 8205, acondicionadas em sortidos para venda a retalho",
    "ncms": [
      "82060000"
    ],
    "segmento": "FERRAMENTAS"
  },
  {
    "codigo": "0801200",
    "descricao": "Ferramentas de roscar interior ou exteriormente; de mandrilar ou de brochar; e de fresar",
    "ncms": [
      "820740",
      "820760",
      "820770"
    ],
    "segmento": "FERRAMENTAS"
  },
  {
    "codigo": "0801300",
    "descricao": "Outras ferramentas intercambiáveis para ferramentas manuais, mesmo mecânicas, ou para máquinas-ferramentas (por exemplo, de embutir, estampar, puncionar, furar, tornear, aparafusar), incluídas as fieiras de estiragem ou de extrusão, para metais, e as ferramentas de perfuração ou de sondagem, exceto forma ou gabarito de produtos em epoxy e as classificadas no CEST 08.012.00",
    "ncms": [
      "8207"
    ],
    "segmento": "FERRAMENTAS"
  },
  {
    "codigo": "0801400",
    "descricao": "Facas e lâminas cortantes, para máquinas ou para aparelhos mecânicos",
    "ncms": [
      "8208"
    ],
    "segmento": "FERRAMENTAS"
  },
  {
    "codigo": "0801500",
    "descricao": "Plaquetas ou pastilhas intercambiáveis",
    "ncms": [
      "82090011"
    ],
    "segmento": "FERRAMENTAS"
  },
  {
    "codigo": "0801600",
    "descricao": "Outras plaquetas, varetas, pontas e objetos semelhantes para ferramentas, não montados, de ceramais (“cermets”), exceto as classificadas no CEST 08.015.00",
    "ncms": [
      "820900"
    ],
    "segmento": "FERRAMENTAS"
  },
  {
    "codigo": "0801700",
    "descricao": "Facas de lâmina cortante ou serrilhada, incluídas as podadeiras de lâmina móvel, e suas lâminas, exceto as de uso doméstico",
    "ncms": [
      "8211"
    ],
    "segmento": "FERRAMENTAS"
  },
  {
    "codigo": "0801800",
    "descricao": "Tesouras e suas lâminas",
    "ncms": [
      "8213"
    ],
    "segmento": "FERRAMENTAS"
  },
  {
    "codigo": "0801900",
    "descricao": "Ferramentas pneumáticas, hidráulicas ou com motor (elétrico ou não elétrico) incorporado, de uso manual, exceto o descrito no CEST 08.019.01",
    "ncms": [
      "8467"
    ],
    "segmento": "FERRAMENTAS"
  },
  {
    "codigo": "0801901",
    "descricao": "Moto-serras portáteis de corrente, com motor incorporado, não elétrico, de uso agrícola",
    "ncms": [
      "84678100"
    ],
    "segmento": "FERRAMENTAS"
  },
  {
    "codigo": "0802000",
    "descricao": "Instrumentos e aparelhos de geodesia, topografia, agrimensura, nivelamento, fotogrametria, hidrografia, oceanografia, hidrologia, meteorologia ou de geofísica, exceto bussolas; telêmetros",
    "ncms": [
      "9015"
    ],
    "segmento": "FERRAMENTAS"
  },
  {
    "codigo": "0802100",
    "descricao": "Instrumentos de desenho, de traçado ou de cálculo; metros, micrômetros, paquímetros, calibres e semelhantes; partes e acessórios",
    "ncms": [
      "90172000"
    ],
    "segmento": "FERRAMENTAS"
  },
  {
    "codigo": "0802200",
    "descricao": "Termômetros, suas partes e acessórios",
    "ncms": [
      "90251190"
    ],
    "segmento": "FERRAMENTAS"
  },
  {
    "codigo": "0802300",
    "descricao": "Pirômetros, suas partes e acessórios",
    "ncms": [
      "902519"
    ],
    "segmento": "FERRAMENTAS"
  },
  {
    "codigo": "0900100",
    "descricao": "Lâmpadas elétricas",
    "ncms": [
      "8539"
    ],
    "segmento": "LÂMPADAS, REATORES E “STARTER”"
  },
  {
    "codigo": "0900200",
    "descricao": "Lâmpadas eletrônicas",
    "ncms": [
      "8540"
    ],
    "segmento": "LÂMPADAS, REATORES E “STARTER”"
  },
  {
    "codigo": "0900300",
    "descricao": "Reatores para lâmpadas ou tubos de descargas",
    "ncms": [
      "85041000"
    ],
    "segmento": "LÂMPADAS, REATORES E “STARTER”"
  },
  {
    "codigo": "0900400",
    "descricao": "“Starter”",
    "ncms": [
      "853650"
    ],
    "segmento": "LÂMPADAS, REATORES E “STARTER”"
  },
  {
    "codigo": "0900500",
    "descricao": "Lâmpadas de LED (diodos emissores de luz)",
    "ncms": [
      "85395200"
    ],
    "segmento": "LÂMPADAS, REATORES E “STARTER”"
  },
  {
    "codigo": "1000100",
    "descricao": "Cal",
    "ncms": [
      "2522"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1000200",
    "descricao": "Argamassas",
    "ncms": [
      "3816001"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1000300",
    "descricao": "Outras argamassas",
    "ncms": [
      "32149000"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1000400",
    "descricao": "Silicones em formas primárias, para uso na construção",
    "ncms": [
      "391000"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1000500",
    "descricao": "Revestimentos de PVC e outros plásticos; forro, sancas e afins de PVC, para uso na construção",
    "ncms": [
      "3916"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1000600",
    "descricao": "Tubos, e seus acessórios (por exemplo, juntas, cotovelos, flanges, uniões), de plásticos, para uso na construção",
    "ncms": [
      "3917"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1000700",
    "descricao": "Revestimento de pavimento de PVC e outros plásticos",
    "ncms": [
      "3918"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1000800",
    "descricao": "Chapas, folhas, tiras, fitas, películas e outras formas planas, autoadesivas, de plásticos, mesmo em rolos, para uso na construção",
    "ncms": [
      "3919"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1000900",
    "descricao": "Veda rosca, lona plástica para uso na construção, fitas isolantes e afins",
    "ncms": [
      "3919"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1001000",
    "descricao": "Telha de plástico, mesmo reforçada com fibra de vidro",
    "ncms": [
      "3921"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1001100",
    "descricao": "Cumeeira de plástico, mesmo reforçada com fibra de vidro",
    "ncms": [
      "3921"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1001200",
    "descricao": "Chapas, laminados plásticos em bobina, para uso na construção, exceto os descritos no CEST 10.010.00 e 10.011.00",
    "ncms": [
      "3921"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1001300",
    "descricao": "Banheiras, boxes para chuveiros, pias, lavatórios, bidês, sanitários e seus assentos e tampas, caixas de descarga e artigos semelhantes para usos sanitários ou higiênicos, de plásticos",
    "ncms": [
      "3922"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1001400",
    "descricao": "Artefatos de higiene/toucador de plástico, para uso na construção",
    "ncms": [
      "3924"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1001500",
    "descricao": "Caixa d’água, inclusive sua tampa, de plástico, mesmo reforçadas com fibra de vidro",
    "ncms": [
      "39251000"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1001600",
    "descricao": "Outras telhas, cumeeira e caixa d’água, inclusive sua tampa, de plástico, mesmo reforçadas com fibra de vidro",
    "ncms": [
      "392590"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1001700",
    "descricao": "Artefatos para apetrechamento de construções, de plásticos, não especificados nem compreendidos em outras posições, incluindo persianas, sancas, molduras, apliques e rosetas, caixilhos de polietileno e outros plásticos, exceto os descritos nos CEST 10.015.00 e 10.016.00",
    "ncms": [
      "39251000"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1001800",
    "descricao": "Portas, janelas e seus caixilhos, alizares e soleiras",
    "ncms": [
      "39252000"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1001900",
    "descricao": "Postigos, estores (incluídas as venezianas) e artefatos semelhantes e suas partes",
    "ncms": [
      "39253000"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1002000",
    "descricao": "Outras obras de plástico, para uso na construção",
    "ncms": [
      "392690"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1002100",
    "descricao": "Papel de parede e revestimentos de parede semelhantes; papel para vitrais",
    "ncms": [
      "4814"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1002200",
    "descricao": "Telhas de concreto",
    "ncms": [
      "68101900"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1002300",
    "descricao": "REVOGADO",
    "ncms": [
      "6811"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1002400",
    "descricao": "Caixas d’água, tanques e reservatórios e suas tampas, telhas, calhas, cumeeiras e afins, de fibrocimento, cimento-celulose ou semelhantes, contendo ou não amianto.",
    "ncms": [
      "6811"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1002500",
    "descricao": "Tijolos, placas (lajes), ladrilhos e outras peças cerâmicas de farinhas siliciosas fósseis (“kieselghur”, tripolita, diatomita, por exemplo) ou de terras siliciosas semelhantes",
    "ncms": [
      "69010000"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1002600",
    "descricao": "Tijolos, placas (lajes), ladrilhos e peças cerâmicas semelhantes, para uso na construção, refratários, que não sejam de farinhas siliciosas fósseis nem de terras siliciosas semelhantes",
    "ncms": [
      "6902"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1002700",
    "descricao": "Tijolos para construção, tijoleiras, tapa-vigas e produtos semelhantes, de cerâmica",
    "ncms": [
      "6904"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1002800",
    "descricao": "Telhas, elementos de chaminés, condutores de fumaça, ornamentos arquitetônicos, de cerâmica, e outros produtos cerâmicos para uso na construção",
    "ncms": [
      "6905"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1002900",
    "descricao": "Tubos, calhas ou algerozes e acessórios para canalizações, de cerâmica",
    "ncms": [
      "69060000"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1003000",
    "descricao": "Ladrilhos e placas de cerâmica, exclusivamente para pavimentação ou revestimento",
    "ncms": [
      "6907"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1003001",
    "descricao": "Cubos, pastilhas e artigos semelhantes de cerâmica, mesmo com suporte, exceto os descritos CEST 10.030.00",
    "ncms": [
      "6907"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1003100",
    "descricao": "Pias, lavatórios, colunas para lavatórios, banheiras, bidês, sanitários, caixas de descarga, mictórios e aparelhos fixos semelhantes para usos sanitários, de cerâmica",
    "ncms": [
      "6910"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1003200",
    "descricao": "Artefatos de higiene/toucador de cerâmica",
    "ncms": [
      "69120000"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1003300",
    "descricao": "Vidro vazado ou laminado, em chapas, folhas ou perfis, mesmo com camada absorvente, refletora ou não, mas sem qualquer outro trabalho",
    "ncms": [
      "7003"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1003400",
    "descricao": "Vidro estirado ou soprado, em folhas, mesmo com camada absorvente, refletora ou não, mas sem qualquer outro trabalho",
    "ncms": [
      "7004"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1003500",
    "descricao": "Vidro flotado e vidro desbastado ou polido em uma ou em ambas as faces, em chapas ou em folhas, mesmo com camada absorvente, refletora ou não, mas sem qualquer outro trabalho",
    "ncms": [
      "7005"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1003600",
    "descricao": "Vidros temperados",
    "ncms": [
      "70071900"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1003700",
    "descricao": "Vidros laminados",
    "ncms": [
      "70072900"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1003800",
    "descricao": "Vidros isolantes de paredes múltiplas",
    "ncms": [
      "7008"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1003900",
    "descricao": "Blocos, placas, tijolos, ladrilhos, telhas e outros artefatos, de vidro prensado ou moldado, mesmo armado, para uso na construção; cubos, pastilhas e outros artigos semelhantes",
    "ncms": [
      "7016"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1004000",
    "descricao": "Barras próprias para construções, exceto vergalhões",
    "ncms": [
      "72142000"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1004100",
    "descricao": "Outras barras próprias para construções, exceto vergalhões",
    "ncms": [
      "73089010"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1004101",
    "descricao": "Outros vergalhões",
    "ncms": [
      "73089010"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1004200",
    "descricao": "Vergalhões",
    "ncms": [
      "72142000"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1004300",
    "descricao": "Outros vergalhões",
    "ncms": [
      "7213"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1004400",
    "descricao": "Fios de ferro ou aço não ligados, não revestidos, mesmo polidos; cordas, cabos, tranças (entrançados), lingas e artefatos semelhantes, de ferro ou aço, não isolados para usos elétricos",
    "ncms": [
      "72171090"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1004500",
    "descricao": "Outros fios de ferro ou aço, não ligados, galvanizados com teor de carbono superior ou igual a 0,6%, em peso",
    "ncms": [
      "72172010"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1004501",
    "descricao": "Outros fios de ferro ou aço, não ligados, galvanizados",
    "ncms": [
      "72172090"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1004600",
    "descricao": "Acessórios para tubos (inclusive uniões, cotovelos, luvas ou mangas), de ferro fundido, ferro ou aço",
    "ncms": [
      "7307"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1004700",
    "descricao": "Portas e janelas, e seus caixilhos, alizares e soleiras de ferro fundido, ferro ou aço",
    "ncms": [
      "73083000"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1004800",
    "descricao": "Material para andaimes, para armações (cofragens) e para escoramentos, (inclusive armações prontas, para estruturas de concreto armado ou argamassa armada), eletrocalhas e perfilados de ferro fundido, ferro ou aço, próprios para construção, exceto treliças de aço",
    "ncms": [
      "73084000"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1004900",
    "descricao": "Treliças de aço",
    "ncms": [
      "73084000"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1005000",
    "descricao": "Telhas metálicas",
    "ncms": [
      "73089090"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1005100",
    "descricao": "Caixas diversas (tais como caixa de correio, de entrada de água, de energia, de instalação) de ferro fundido, ferro ou aço; próprias para a construção",
    "ncms": [
      "7310"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1005200",
    "descricao": "Arame farpado, de ferro ou aço, arames ou tiras, retorcidos, mesmo farpados, de ferro ou aço, dos tipos utilizados em cercas",
    "ncms": [
      "73130000"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1005300",
    "descricao": "Telas metálicas, grades e redes, de fios de ferro ou aço",
    "ncms": [
      "7314"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1005400",
    "descricao": "Correntes de rolos, de ferro fundido, ferro ou aço",
    "ncms": [
      "73151100"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1005500",
    "descricao": "Outras correntes de elos articulados, de ferro fundido, ferro ou aço",
    "ncms": [
      "73151290"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1005600",
    "descricao": "Correntes de elos soldados, de ferro fundido, de ferro ou aço",
    "ncms": [
      "73158200"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1005700",
    "descricao": "Tachas, pregos, percevejos, escápulas, grampos ondulados ou biselados e artefatos semelhantes, de ferro fundido, ferro ou aço, mesmo com a cabeça de outra matéria, exceto cobre",
    "ncms": [
      "731700"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1005800",
    "descricao": "Parafusos, pinos ou pernos, roscados, porcas, tira-fundos, ganchos roscados, rebites, chavetas, contrapinos ou troços, arruelas (anilhas) (incluindo as de pressão) e artigos semelhantes, de ferro fundido, ferro ou aço",
    "ncms": [
      "7318"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1005900",
    "descricao": "Palha de ferro ou aço, exceto os de uso doméstico classificados na posição NCM 7323.10.00",
    "ncms": [
      "7323"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1005901",
    "descricao": "Esponjas, esfregões, luvas e artefatos semelhantes para limpeza, polimento e usos semelhantes, de ferro ou aço, exceto os de uso doméstico classificados na posição NCM 7323.10.00",
    "ncms": [
      "7323"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1006000",
    "descricao": "Artefatos de higiene ou de toucador, e suas partes, de ferro fundido, ferro ou aço, incluídas as pias, banheiras, lavatórios, cubas, mictórios, tanques e afins de ferro fundido, ferro ou aço, para uso na construção",
    "ncms": [
      "7324"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1006100",
    "descricao": "Outras obras moldadas, de ferro fundido, ferro ou aço, para uso na construção",
    "ncms": [
      "7325"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1006200",
    "descricao": "Abraçadeiras",
    "ncms": [
      "7326"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1006300",
    "descricao": "Barras de cobre",
    "ncms": [
      "7407"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1006400",
    "descricao": "Tubos de cobre e suas ligas, para instalações de água quente e gás, para uso na construção",
    "ncms": [
      "74111010"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1006500",
    "descricao": "Acessórios para tubos (por exemplo, uniões, cotovelos, luvas ou mangas) de cobre e suas ligas, para uso na construção",
    "ncms": [
      "7412"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1006600",
    "descricao": "Tachas, pregos, percevejos, escápulas e artefatos semelhantes, de cobre, ou de ferro ou aço com cabeça de cobre, parafusos, pinos ou pernos, roscados, porcas, ganchos roscados, rebites, chavetas, cavilhas, contrapinos, arruelas (incluídas as de pressão), e artefatos semelhantes, de cobre",
    "ncms": [
      "7415"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1006700",
    "descricao": "Artefatos de higiene/toucador de cobre, para uso na construção",
    "ncms": [
      "74182000"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1006800",
    "descricao": "Manta de subcobertura aluminizada",
    "ncms": [
      "76071990"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1006900",
    "descricao": "Tubos de alumínio e suas ligas, para refrigeração e ar condicionado, para uso na construção",
    "ncms": [
      "7608"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1007000",
    "descricao": "Acessórios para tubos (por exemplo, uniões, cotovelos, luvas ou mangas), de alumínio, para uso na construção",
    "ncms": [
      "76090000"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1007100",
    "descricao": "Construções e suas partes (por exemplo, pontes e elementos de pontes, torres, pórticos ou pilones, pilares, colunas, armações, estruturas para telhados, portas e janelas, e seus caixilhos, alizares e soleiras, balaustradas), de alumínio, exceto as construções pré-fabricadas da posição 9406; chapas, barras, perfis, tubos e semelhantes, de alumínio, próprios para construções",
    "ncms": [
      "7610"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1007200",
    "descricao": "Artefatos de higiene/toucador de alumínio, para uso na construção",
    "ncms": [
      "76152000"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1007300",
    "descricao": "Outras obras de alumínio, próprias para construções, incluídas as persianas",
    "ncms": [
      "7616"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1007400",
    "descricao": "Outras guarnições, ferragens e artigos semelhantes de metais comuns, para construções, inclusive puxadores.",
    "ncms": [
      "83024100"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1007500",
    "descricao": "Fechaduras e ferrolhos (de chave, de segredo ou elétricos), de metais comuns, incluídas as suas partes fechos e armações com fecho, com fechadura, de metais comuns chaves para estes artigos, de metais comuns; exceto os de uso automotivo",
    "ncms": [
      "8301"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1007600",
    "descricao": "Dobradiças de metais comuns, de qualquer tipo",
    "ncms": [
      "83021000"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1007700",
    "descricao": "Tubos flexíveis de metais comuns, mesmo com acessórios, para uso na construção",
    "ncms": [
      "8307"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1007800",
    "descricao": "Fios, varetas, tubos, chapas, eletrodos e artefatos semelhantes, de metais comuns ou de carbonetos metálicos, revestidos exterior ou interiormente de decapantes ou de fundentes, para soldagem (soldadura) ou depósito de metal ou de carbonetos metálicos fios e varetas de pós de metais comuns aglomerados, para metalização por projeção",
    "ncms": [
      "8311"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1007900",
    "descricao": "Torneiras, válvulas (incluídas as redutoras de pressão e as termostáticas) e dispositivos semelhantes, para canalizações, caldeiras, reservatórios, cubas e outros recipientes",
    "ncms": [
      "8481"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1008000",
    "descricao": "Espelhos de vidro, mesmo emoldurados, exceto os de uso automotivo",
    "ncms": [
      "7009"
    ],
    "segmento": "MATERIAIS DE CONSTRUÇÃO E CONGÊNERES"
  },
  {
    "codigo": "1100100",
    "descricao": "Água sanitária, branqueador e outros alvejantes",
    "ncms": [
      "28289011"
    ],
    "segmento": "MATERIAIS DE LIMPEZA"
  },
  {
    "codigo": "1100200",
    "descricao": "Sabões, desinfetantes e sanitizantes, todos em pó, flocos, palhetas, grânulos ou outras formas semelhantes, para lavar roupas",
    "ncms": [
      "34012090"
    ],
    "segmento": "MATERIAIS DE LIMPEZA"
  },
  {
    "codigo": "1100300",
    "descricao": "Sabões, desinfetantes e sanitizantes, todos líquidos para lavar roupas",
    "ncms": [
      "34012090"
    ],
    "segmento": "MATERIAIS DE LIMPEZA"
  },
  {
    "codigo": "1100400",
    "descricao": "Detergentes em pó, flocos, palhetas, grânulos ou outras formas semelhantes, inclusive adicionados de propriedades desinfetantes ou sanitizantes.",
    "ncms": [
      "34025000"
    ],
    "segmento": "MATERIAIS DE LIMPEZA"
  },
  {
    "codigo": "1100500",
    "descricao": "Detergentes líquidos, exceto para lavar roupa",
    "ncms": [
      "34025000"
    ],
    "segmento": "MATERIAIS DE LIMPEZA"
  },
  {
    "codigo": "1100600",
    "descricao": "Detergente líquido para lavar roupa, inclusive adicionados de propriedades desinfetantes ou sanitizantes.",
    "ncms": [
      "34025000"
    ],
    "segmento": "MATERIAIS DE LIMPEZA"
  },
  {
    "codigo": "1100700",
    "descricao": "Outros agentes orgânicos de superfície (exceto sabões); preparações tensoativas, preparações para lavagem (incluídas as preparações auxiliares para lavagem) e preparações para limpeza (inclusive multiuso e limpadores), mesmo contendo sabão, exceto os produtos descritos nos CEST 11.001.00, 11.004.00, 11.005.00 e 11.006.00; em embalagem de conteúdo inferior ou igual a 50 litros ou 50 kg",
    "ncms": [
      "3402"
    ],
    "segmento": "MATERIAIS DE LIMPEZA"
  },
  {
    "codigo": "1100800",
    "descricao": "Amaciante/suavizante",
    "ncms": [
      "38099190"
    ],
    "segmento": "MATERIAIS DE LIMPEZA"
  },
  {
    "codigo": "1100900",
    "descricao": "Esponjas para limpeza",
    "ncms": [
      "39241000"
    ],
    "segmento": "MATERIAIS DE LIMPEZA"
  },
  {
    "codigo": "1101000",
    "descricao": "Álcool etílico para limpeza",
    "ncms": [
      "2207"
    ],
    "segmento": "MATERIAIS DE LIMPEZA"
  },
  {
    "codigo": "1101100",
    "descricao": "Esponjas e palhas de aço; esponjas para limpeza, polimento ou uso semelhantes; todas de uso doméstico",
    "ncms": [
      "73231000"
    ],
    "segmento": "MATERIAIS DE LIMPEZA"
  },
  {
    "codigo": "1101200",
    "descricao": "Sacos de lixo de conteúdo igual ou inferior a 100 litros",
    "ncms": [
      "39232"
    ],
    "segmento": "MATERIAIS DE LIMPEZA"
  },
  {
    "codigo": "1200100",
    "descricao": "Transformadores, bobinas de reatância e de auto indução, inclusive os transformadores de potência superior a 16 KVA, classificados nas posições 8504.33.00 e 8504.34.00; exceto os demais transformadores da subposição 8504.3, os reatores para lâmpadas elétricas de descarga classificados no código 8504.10.00, os carregadores de acumuladores do código 8504.40.10, os equipamentos de alimentação ininterrupta de energia (UPS ou “no break”), no código 8504.40.40 e os de uso automotivo",
    "ncms": [
      "8504"
    ],
    "segmento": "MATERIAIS ELÉTRICOS"
  },
  {
    "codigo": "1200200",
    "descricao": "Aquecedores elétricos de água, incluídos os de imersão, chuveiros ou duchas elétricos, torneiras elétricas, resistências de aquecimento, inclusive as de duchas e chuveiros elétricos e suas partes; exceto outros fornos, fogareiros (incluídas as chapas de cocção), grelhas e assadeiras, classificados na posição 8516.60.00",
    "ncms": [
      "8516"
    ],
    "segmento": "MATERIAIS ELÉTRICOS"
  },
  {
    "codigo": "1200300",
    "descricao": "Aparelhos para interrupção, seccionamento, proteção, derivação, ligação ou conexão de circuitos elétricos (por exemplo, interruptores, comutadores, corta-circuitos, para-raios, limitadores de tensão, eliminadores de onda, tomadas de corrente e outros conectores, caixas de junção), para tensão superior a 1.000V, exceto os de uso automotivo",
    "ncms": [
      "8535"
    ],
    "segmento": "MATERIAIS ELÉTRICOS"
  },
  {
    "codigo": "1200400",
    "descricao": "Aparelhos para interrupção, seccionamento, proteção, derivação, ligação ou conexão de circuitos elétricos (por exemplo, interruptores, comutadores, relés, corta-circuitos, eliminadores de onda, plugues e tomadas de corrente, suportes para lâmpadas e outros conectores, caixas de junção), para uma tensão não superior a 1.000V; conectores para fibras ópticas, feixes ou cabos de fibras ópticas; exceto “starter” classificado na subposição 8536.50 e os de uso automotivo",
    "ncms": [
      "8536"
    ],
    "segmento": "MATERIAIS ELÉTRICOS"
  },
  {
    "codigo": "1200500",
    "descricao": "Partes reconhecíveis como exclusiva ou principalmente destinadas aos aparelhos das posições 8535 e 8536",
    "ncms": [
      "8538"
    ],
    "segmento": "MATERIAIS ELÉTRICOS"
  },
  {
    "codigo": "1200600",
    "descricao": "Cabos, tranças e semelhantes, de cobre, não isolados para usos elétricos, exceto os de uso automotivo",
    "ncms": [
      "74130000"
    ],
    "segmento": "MATERIAIS ELÉTRICOS"
  },
  {
    "codigo": "1200700",
    "descricao": "Fios, cabos (incluídos os cabos coaxiais) e outros condutores, isolados ou não, para usos elétricos (incluídos os de cobre ou alumínio, envernizados ou oxidados anodicamente), mesmo com peças de conexão, inclusive fios e cabos elétricos, para tensão não superior a 1000V, para uso na construção; fios e cabos telefônicos e para transmissão de dados; cabos de fibras ópticas, constituídos de fibras embainhadas individualmente, mesmo com condutores elétricos ou munidos de peças de conexão; cordas, cabos, tranças e semelhantes, de alumínio, não isolados para uso elétricos; exceto os de uso automotivo",
    "ncms": [
      "8544"
    ],
    "segmento": "MATERIAIS ELÉTRICOS"
  },
  {
    "codigo": "1200800",
    "descricao": "Isoladores de qualquer matéria, para usos elétricos",
    "ncms": [
      "8546"
    ],
    "segmento": "MATERIAIS ELÉTRICOS"
  },
  {
    "codigo": "1200900",
    "descricao": "Peças isolantes inteiramente de matérias isolantes, ou com simples peças metálicas de montagem (suportes roscados, por exemplo) incorporadas na massa, para máquinas, aparelhos e instalações elétricas; tubos isoladores e suas peças de ligação, de metais comuns, isolados interiormente",
    "ncms": [
      "8547"
    ],
    "segmento": "MATERIAIS ELÉTRICOS"
  },
  {
    "codigo": "1300100",
    "descricao": "Medicamentos de referência - positiva, exceto para uso veterinário",
    "ncms": [
      "3003"
    ],
    "segmento": "FARMACÊUTICOS PARA USO HUMANO OU VETERINÁRIO"
  },
  {
    "codigo": "1300101",
    "descricao": "Medicamentos de referência - negativa, exceto para uso veterinário",
    "ncms": [
      "3003"
    ],
    "segmento": "FARMACÊUTICOS PARA USO HUMANO OU VETERINÁRIO"
  },
  {
    "codigo": "1300102",
    "descricao": "Medicamentos de referência - neutra, exceto para uso veterinário",
    "ncms": [
      "3003"
    ],
    "segmento": "FARMACÊUTICOS PARA USO HUMANO OU VETERINÁRIO"
  },
  {
    "codigo": "1300200",
    "descricao": "Medicamentos genérico - positiva, exceto para uso veterinário",
    "ncms": [
      "3003"
    ],
    "segmento": "FARMACÊUTICOS PARA USO HUMANO OU VETERINÁRIO"
  },
  {
    "codigo": "1300201",
    "descricao": "Medicamentos genérico - negativa, exceto para uso veterinário",
    "ncms": [
      "3003"
    ],
    "segmento": "FARMACÊUTICOS PARA USO HUMANO OU VETERINÁRIO"
  },
  {
    "codigo": "1300202",
    "descricao": "Medicamentos genérico - neutra, exceto para uso veterinário",
    "ncms": [
      "3003"
    ],
    "segmento": "FARMACÊUTICOS PARA USO HUMANO OU VETERINÁRIO"
  },
  {
    "codigo": "1300300",
    "descricao": "Medicamentos similar - positiva, exceto para uso veterinário",
    "ncms": [
      "3003"
    ],
    "segmento": "FARMACÊUTICOS PARA USO HUMANO OU VETERINÁRIO"
  },
  {
    "codigo": "1300301",
    "descricao": "Medicamentos similar - negativa, exceto para uso veterinário",
    "ncms": [
      "3003"
    ],
    "segmento": "FARMACÊUTICOS PARA USO HUMANO OU VETERINÁRIO"
  },
  {
    "codigo": "1300302",
    "descricao": "Medicamentos similar - neutra, exceto para uso veterinário",
    "ncms": [
      "3003"
    ],
    "segmento": "FARMACÊUTICOS PARA USO HUMANO OU VETERINÁRIO"
  },
  {
    "codigo": "1300400",
    "descricao": "Outros tipos de medicamentos - positiva, exceto para uso veterinário",
    "ncms": [
      "3003"
    ],
    "segmento": "FARMACÊUTICOS PARA USO HUMANO OU VETERINÁRIO"
  },
  {
    "codigo": "1300401",
    "descricao": "Outros tipos de medicamentos - negativa, exceto para uso veterinário",
    "ncms": [
      "3003"
    ],
    "segmento": "FARMACÊUTICOS PARA USO HUMANO OU VETERINÁRIO"
  },
  {
    "codigo": "1300402",
    "descricao": "Outros tipos de medicamentos - neutra, exceto para uso veterinário",
    "ncms": [
      "3003"
    ],
    "segmento": "FARMACÊUTICOS PARA USO HUMANO OU VETERINÁRIO"
  },
  {
    "codigo": "1300500",
    "descricao": "Preparações químicas contraceptivas de referência, à base de hormônios, de outros produtos da posição 29.37 ou de espermicidas - positiva.",
    "ncms": [
      "30066000"
    ],
    "segmento": "FARMACÊUTICOS PARA USO HUMANO OU VETERINÁRIO"
  },
  {
    "codigo": "1300501",
    "descricao": "Preparações químicas contraceptivas de referência, à base de hormônios, de outros produtos da posição 29.37 ou de espermicidas - negativa.",
    "ncms": [
      "30066000"
    ],
    "segmento": "FARMACÊUTICOS PARA USO HUMANO OU VETERINÁRIO"
  },
  {
    "codigo": "1300502",
    "descricao": "Preparações químicas contraceptivas genérico, à base de hormônios, de outros produtos da posição 29.37 ou de espermicidas – positiva.",
    "ncms": [
      "30066000"
    ],
    "segmento": "FARMACÊUTICOS PARA USO HUMANO OU VETERINÁRIO"
  },
  {
    "codigo": "1300503",
    "descricao": "Preparações químicas contraceptivas genérico, à base de hormônios, de outros produtos da posição 29.37 ou de espermicidas – negativa.",
    "ncms": [
      "30066000"
    ],
    "segmento": "FARMACÊUTICOS PARA USO HUMANO OU VETERINÁRIO"
  },
  {
    "codigo": "1300504",
    "descricao": "Preparações químicas contraceptivas similar, à base de hormônios, de outros produtos da posição 29.37 ou de espermicidas – positiva.",
    "ncms": [
      "30066000"
    ],
    "segmento": "FARMACÊUTICOS PARA USO HUMANO OU VETERINÁRIO"
  },
  {
    "codigo": "1300505",
    "descricao": "Preparações químicas contraceptivas similar, à base de hormônios, de outros produtos da posição 29.37 ou de espermicidas – negativa.",
    "ncms": [
      "30066000"
    ],
    "segmento": "FARMACÊUTICOS PARA USO HUMANO OU VETERINÁRIO"
  },
  {
    "codigo": "1300600",
    "descricao": "Provitaminas e vitaminas, naturais ou reproduzidas por síntese (incluídos os concentrados naturais), bem como os seus derivados utilizados principalmente como vitaminas, misturados ou não entre si, mesmo em quaisquer soluções - neutra",
    "ncms": [
      "2936"
    ],
    "segmento": "FARMACÊUTICOS PARA USO HUMANO OU VETERINÁRIO"
  },
  {
    "codigo": "1300700",
    "descricao": "Preparações opacificantes (contrastantes) para exames radiográficos e reagentes de diagnóstico concebidos para serem administrados ao paciente - positiva",
    "ncms": [
      "300630"
    ],
    "segmento": "FARMACÊUTICOS PARA USO HUMANO OU VETERINÁRIO"
  },
  {
    "codigo": "1300701",
    "descricao": "Preparações opacificantes (contrastantes) para exames radiográficos e reagentes de diagnóstico concebidos para serem administrados ao paciente - negativa",
    "ncms": [
      "300630"
    ],
    "segmento": "FARMACÊUTICOS PARA USO HUMANO OU VETERINÁRIO"
  },
  {
    "codigo": "1300800",
    "descricao": "Antissoro, outras frações do sangue, produtos imunológicos modificados, mesmo obtidos por via biotecnológica, exceto para uso veterinário - positiva",
    "ncms": [
      "3002"
    ],
    "segmento": "FARMACÊUTICOS PARA USO HUMANO OU VETERINÁRIO"
  },
  {
    "codigo": "1300801",
    "descricao": "Antissoro, outras frações do sangue, produtos imunológicos modificados, mesmo obtidos por via biotecnológica, exceto para uso veterinário - negativa",
    "ncms": [
      "3002"
    ],
    "segmento": "FARMACÊUTICOS PARA USO HUMANO OU VETERINÁRIO"
  },
  {
    "codigo": "1300900",
    "descricao": "Vacinas e produtos semelhantes, exceto para uso veterinário - positiva;",
    "ncms": [
      "3002"
    ],
    "segmento": "FARMACÊUTICOS PARA USO HUMANO OU VETERINÁRIO"
  },
  {
    "codigo": "1300901",
    "descricao": "Vacinas e produtos semelhantes, exceto para uso veterinário - negativa;",
    "ncms": [
      "3002"
    ],
    "segmento": "FARMACÊUTICOS PARA USO HUMANO OU VETERINÁRIO"
  },
  {
    "codigo": "1301000",
    "descricao": "Curativos (pensos) adesivos e outros artigos com uma camada adesiva, impregnados ou recobertos de substâncias farmacêuticas - Lista Positiva",
    "ncms": [
      "30051010"
    ],
    "segmento": "FARMACÊUTICOS PARA USO HUMANO OU VETERINÁRIO"
  },
  {
    "codigo": "1301001",
    "descricao": "Curativos (pensos) adesivos e outros artigos com uma camada adesiva, impregnados ou recobertos de substâncias farmacêuticas - Lista Negativa",
    "ncms": [
      "30051010"
    ],
    "segmento": "FARMACÊUTICOS PARA USO HUMANO OU VETERINÁRIO"
  },
  {
    "codigo": "1301100",
    "descricao": "Algodão, atadura, esparadrapo, gazes, pensos, sinapismos, e outros, acondicionados para venda a retalho para usos medicinais, cirúrgicos ou dentários, não impregnados ou recobertos de substâncias farmacêuticas - Lista Neutra",
    "ncms": [
      "3005"
    ],
    "segmento": "FARMACÊUTICOS PARA USO HUMANO OU VETERINÁRIO"
  },
  {
    "codigo": "1301200",
    "descricao": "Luvas cirúrgicas e luvas de procedimento - neutra",
    "ncms": [
      "40151200"
    ],
    "segmento": "FARMACÊUTICOS PARA USO HUMANO OU VETERINÁRIO"
  },
  {
    "codigo": "1301300",
    "descricao": "Preservativo – neutra",
    "ncms": [
      "40141000"
    ],
    "segmento": "FARMACÊUTICOS PARA USO HUMANO OU VETERINÁRIO"
  },
  {
    "codigo": "1301400",
    "descricao": "Seringas, mesmo com agulhas - neutra",
    "ncms": [
      "901831"
    ],
    "segmento": "FARMACÊUTICOS PARA USO HUMANO OU VETERINÁRIO"
  },
  {
    "codigo": "1301500",
    "descricao": "Agulhas para seringas - neutra",
    "ncms": [
      "9018321"
    ],
    "segmento": "FARMACÊUTICOS PARA USO HUMANO OU VETERINÁRIO"
  },
  {
    "codigo": "1301600",
    "descricao": "Contraceptivos (dispositivos intrauterinos - DIU) - neutra",
    "ncms": [
      "39269090"
    ],
    "segmento": "FARMACÊUTICOS PARA USO HUMANO OU VETERINÁRIO"
  },
  {
    "codigo": "1400100",
    "descricao": "Objetos de vidro para serviço de mesa ou de cozinha",
    "ncms": [
      "7013"
    ],
    "segmento": "PAPÉIS, PLÁSTICOS, PRODUTOS CERÂMICOS E VIDROS"
  },
  {
    "codigo": "1400200",
    "descricao": "Outros copos, exceto de vitrocerâmica",
    "ncms": [
      "70133700"
    ],
    "segmento": "PAPÉIS, PLÁSTICOS, PRODUTOS CERÂMICOS E VIDROS"
  },
  {
    "codigo": "1400300",
    "descricao": "Objetos para serviço de mesa (exceto copos) ou de cozinha, exceto de vitrocerâmica",
    "ncms": [
      "70134290"
    ],
    "segmento": "PAPÉIS, PLÁSTICOS, PRODUTOS CERÂMICOS E VIDROS"
  },
  {
    "codigo": "1400400",
    "descricao": "Lonas plásticas, exceto as para uso na construção",
    "ncms": [
      "3919"
    ],
    "segmento": "PAPÉIS, PLÁSTICOS, PRODUTOS CERÂMICOS E VIDROS"
  },
  {
    "codigo": "1400500",
    "descricao": "Artefatos de higiene/toucador de plástico, exceto os para uso na construção",
    "ncms": [
      "3924"
    ],
    "segmento": "PAPÉIS, PLÁSTICOS, PRODUTOS CERÂMICOS E VIDROS"
  },
  {
    "codigo": "1400600",
    "descricao": "Serviços de mesa e outros utensílios de mesa ou de cozinha, de plástico, não descartáveis",
    "ncms": [
      "39241000"
    ],
    "segmento": "PAPÉIS, PLÁSTICOS, PRODUTOS CERÂMICOS E VIDROS"
  },
  {
    "codigo": "1400601",
    "descricao": "Serviços de mesa e outros utensílios de mesa ou de cozinha, de plástico, descartáveis",
    "ncms": [
      "39241000"
    ],
    "segmento": "PAPÉIS, PLÁSTICOS, PRODUTOS CERÂMICOS E VIDROS"
  },
  {
    "codigo": "1400700",
    "descricao": "Artigos para serviço de mesa ou de cozinha, de porcelana, inclusive os descartáveis - estojos",
    "ncms": [
      "69111010"
    ],
    "segmento": "PAPÉIS, PLÁSTICOS, PRODUTOS CERÂMICOS E VIDROS"
  },
  {
    "codigo": "1400800",
    "descricao": "Artigos para serviço de mesa ou de cozinha, de porcelana, inclusive os descartáveis - avulsos",
    "ncms": [
      "69111090"
    ],
    "segmento": "PAPÉIS, PLÁSTICOS, PRODUTOS CERÂMICOS E VIDROS"
  },
  {
    "codigo": "1400900",
    "descricao": "Artigos para serviço de mesa ou de cozinha, de cerâmica",
    "ncms": [
      "69120000"
    ],
    "segmento": "PAPÉIS, PLÁSTICOS, PRODUTOS CERÂMICOS E VIDROS"
  },
  {
    "codigo": "1401000",
    "descricao": "Velas para filtros",
    "ncms": [
      "69120000"
    ],
    "segmento": "PAPÉIS, PLÁSTICOS, PRODUTOS CERÂMICOS E VIDROS"
  },
  {
    "codigo": "1401100",
    "descricao": "Filtros descartáveis para coar café ou chá",
    "ncms": [
      "4823209"
    ],
    "segmento": "PAPÉIS, PLÁSTICOS, PRODUTOS CERÂMICOS E VIDROS"
  },
  {
    "codigo": "1401200",
    "descricao": "Bandejas, travessas, pratos, xícaras ou chávenas, taças, copos e artigos semelhantes, de papel ou cartão",
    "ncms": [
      "48236"
    ],
    "segmento": "PAPÉIS, PLÁSTICOS, PRODUTOS CERÂMICOS E VIDROS"
  },
  {
    "codigo": "1401300",
    "descricao": "Papel para cigarro",
    "ncms": [
      "48131000"
    ],
    "segmento": "PAPÉIS, PLÁSTICOS, PRODUTOS CERÂMICOS E VIDROS"
  },
  {
    "codigo": "1600100",
    "descricao": "Pneus novos, dos tipos utilizados em automóveis de passageiros (incluídos os veículos de uso misto - camionetas e os automóveis de corrida)",
    "ncms": [
      "40111000"
    ],
    "segmento": "PNEUMÁTICOS, CÂMARAS DE AR E PROTETORES DE BORRACHA"
  },
  {
    "codigo": "1600200",
    "descricao": "Pneus novos, dos tipos utilizados em caminhões (inclusive para os fora-de-estrada), ônibus, aviões, máquinas de terraplenagem, de construção e conservação de estradas, máquinas e tratores agrícolas, pá-carregadeira",
    "ncms": [
      "4011"
    ],
    "segmento": "PNEUMÁTICOS, CÂMARAS DE AR E PROTETORES DE BORRACHA"
  },
  {
    "codigo": "1600300",
    "descricao": "Pneus novos para motocicletas",
    "ncms": [
      "40114000"
    ],
    "segmento": "PNEUMÁTICOS, CÂMARAS DE AR E PROTETORES DE BORRACHA"
  },
  {
    "codigo": "1600400",
    "descricao": "Outros tipos de pneus novos, exceto os itens classificados no CEST 16.005.00",
    "ncms": [
      "4011"
    ],
    "segmento": "PNEUMÁTICOS, CÂMARAS DE AR E PROTETORES DE BORRACHA"
  },
  {
    "codigo": "1600500",
    "descricao": "Pneus novos de borracha dos tipos utilizados em bicicletas",
    "ncms": [
      "40115000"
    ],
    "segmento": "PNEUMÁTICOS, CÂMARAS DE AR E PROTETORES DE BORRACHA"
  },
  {
    "codigo": "1600600",
    "descricao": "Pneus recauchutados",
    "ncms": [
      "40121"
    ],
    "segmento": "PNEUMÁTICOS, CÂMARAS DE AR E PROTETORES DE BORRACHA"
  },
  {
    "codigo": "1600700",
    "descricao": "Protetores de borracha, exceto os itens classificados no CEST 16.007.01",
    "ncms": [
      "401290"
    ],
    "segmento": "PNEUMÁTICOS, CÂMARAS DE AR E PROTETORES DE BORRACHA"
  },
  {
    "codigo": "1600701",
    "descricao": "Protetores de borracha para bicicletas",
    "ncms": [
      "401290"
    ],
    "segmento": "PNEUMÁTICOS, CÂMARAS DE AR E PROTETORES DE BORRACHA"
  },
  {
    "codigo": "1600800",
    "descricao": "Câmaras de ar de borracha, exceto os itens classificados no CEST 16.009.00",
    "ncms": [
      "4013"
    ],
    "segmento": "PNEUMÁTICOS, CÂMARAS DE AR E PROTETORES DE BORRACHA"
  },
  {
    "codigo": "1600900",
    "descricao": "Câmaras de ar de borracha dos tipos utilizados em bicicletas",
    "ncms": [
      "40132000"
    ],
    "segmento": "PNEUMÁTICOS, CÂMARAS DE AR E PROTETORES DE BORRACHA"
  },
  {
    "codigo": "1700100",
    "descricao": "Chocolate branco, em embalagens de conteúdo inferior ou igual a 1 kg, exceto os classificados no CEST 17.005.00",
    "ncms": [
      "17049010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1700101",
    "descricao": "Chocolate branco, em embalagens de conteúdo superior a 1 kg e inferior ou igual a 2 kg, exceto os classificados no CEST 17.005.00",
    "ncms": [
      "17049010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1700102",
    "descricao": "Coberturas de chocolate branco e outros produtos de confeitaria com manteiga de cacau, em embalagens de conteúdo inferior ou igual a 1 kg, exceto os classificados no CEST 17.008.00",
    "ncms": [
      "17049090"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1700103",
    "descricao": "Coberturas de chocolate branco e outros produtos de confeitaria com manteiga de cacau, em embalagens de conteúdo superior a 1 kg e inferior ou igual a 2 kg, exceto os classificados no CEST 17.008.00",
    "ncms": [
      "17049090"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1700200",
    "descricao": "Chocolates, em tabletes, barras ou paus, recheados, em recipientes ou embalagens imediatas de conteúdo inferior ou igual a 1 kg",
    "ncms": [
      "18063110"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1700201",
    "descricao": "Chocolates, em tabletes, barras ou paus, recheados, em recipientes ou embalagens de conteúdo superior a 1 kg e inferior ou igual a 2 kg",
    "ncms": [
      "18063110"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1700202",
    "descricao": "Outras preparações alimentícias que contenham cacau, em tabletes, barras ou paus, recheados, em recipientes ou embalagens imediatas de conteúdo inferior ou igual a 1 kg",
    "ncms": [
      "18063120"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1700203",
    "descricao": "Outras preparações alimentícias que contenham cacau, em tabletes, barras ou paus, recheados, em recipientes ou embalagens de conteúdo superior a 1 kg e inferior ou igual a 2 kg",
    "ncms": [
      "18063120"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1700300",
    "descricao": "Chocolates, em tabletes, barras ou paus, não recheados, em recipientes ou embalagens imediatas de conteúdo inferior ou igual a 2 kg",
    "ncms": [
      "18063210"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1700301",
    "descricao": "Outras preparações alimentícias que contenham cacau, em tabletes, barras ou paus, não recheados, em recipientes ou embalagens imediatas de conteúdo inferior ou igual a 2 kg",
    "ncms": [
      "18063220"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1700400",
    "descricao": "Chocolates e outras preparações alimentícias contendo cacau, em embalagens de conteúdo inferior ou igual a 1 kg, exceto os classificados nos CEST 17.005.01, 17.006.00, 17.006.02, 17.007.00 e 17.109.00",
    "ncms": [
      "18069000"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1700500",
    "descricao": "Ovos de páscoa de chocolate branco",
    "ncms": [
      "17049010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1700501",
    "descricao": "Ovos de páscoa de chocolate",
    "ncms": [
      "18069000"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1700600",
    "descricao": "Achocolatados em pó, em embalagens de conteúdo inferior ou igual a 1 kg, exceto os classificados no CEST 17.006.02",
    "ncms": [
      "18069000"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1700601",
    "descricao": "Cacau em pó, com adição de açúcar ou de outros edulcorantes, em embalagens de conteúdo inferior ou igual a 1kg",
    "ncms": [
      "18061000"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1700602",
    "descricao": "Achocolatados em pó, em cápsulas",
    "ncms": [
      "18069000"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1700700",
    "descricao": "Caixas de bombons contendo cacau, em embalagens de conteúdo inferior ou igual a 1 kg",
    "ncms": [
      "18069000"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1700800",
    "descricao": "Bombons, inclusive à base de chocolate branco sem cacau",
    "ncms": [
      "17049090"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1700900",
    "descricao": "Bombons, balas, caramelos, confeitos, pastilhas e outros produtos de confeitaria, contendo cacau",
    "ncms": [
      "18069000"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1701000",
    "descricao": "Sucos de frutas ou de produtos hortícolas; mistura de sucos",
    "ncms": [
      "2009"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1701100",
    "descricao": "Água de coco",
    "ncms": [
      "2009892",
      "20098"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1701200",
    "descricao": "Leite em pó, blocos ou grânulos, exceto creme de leite",
    "ncms": [
      "04021"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1701300",
    "descricao": "Farinha láctea",
    "ncms": [
      "19011020"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1701400",
    "descricao": "Leite modificado para alimentação de crianças",
    "ncms": [
      "19011010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1701500",
    "descricao": "Preparações para alimentação infantil à base de farinhas, grumos, sêmolas ou amidos e outros",
    "ncms": [
      "19011090"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1701600",
    "descricao": "Leite “longa vida” (UHT - “Ultra High Temperature”), em recipiente de conteúdo inferior ou igual a 2 litros",
    "ncms": [
      "04011010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1701601",
    "descricao": "Leite “longa vida” (UHT - “Ultra High Temperature”), em recipiente de conteúdo superior a 2 litros e inferior ou igual a 5 litros",
    "ncms": [
      "04011010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1701700",
    "descricao": "Leite em recipiente de conteúdo inferior ou igual a 1 litro",
    "ncms": [
      "04014010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1701701",
    "descricao": "Leite em recipiente de conteúdo superior a 1 litro e inferior ou igual a 5 litros",
    "ncms": [
      "04014010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1701800",
    "descricao": "Leite do tipo pasteurizado em recipiente de conteúdo inferior ou igual a 1 litro",
    "ncms": [
      "04011090"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1701801",
    "descricao": "Leite do tipo pasteurizado em recipiente de conteúdo superior a 1 litro e inferior ou igual a 5 litros",
    "ncms": [
      "04011090"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1701900",
    "descricao": "Creme de leite, em recipiente de conteúdo inferior ou igual a 1 kg",
    "ncms": [
      "0401402"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1701901",
    "descricao": "Creme de leite, em recipiente de conteúdo superior a 1 kg",
    "ncms": [
      "0401402"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1701902",
    "descricao": "Outros cremes de leite, em recipiente de conteúdo inferior ou igual a 1kg",
    "ncms": [
      "040110"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1701903",
    "descricao": "Outros cremes de leite, em recipiente de conteúdo superior a 1kg",
    "ncms": [
      "040110"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1702000",
    "descricao": "Leite condensado, em recipiente de conteúdo inferior ou igual a 1 kg",
    "ncms": [
      "04029"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1702001",
    "descricao": "Leite condensado, em recipiente de conteúdo superior a 1 kg",
    "ncms": [
      "04029"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1702100",
    "descricao": "Iogurte e leite fermentado em recipiente de conteúdo inferior ou igual a 2 litros, exceto o item classificado no CEST 17.022.00",
    "ncms": [
      "0403"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1702101",
    "descricao": "Iogurte e leite fermentado em recipiente de conteúdo superior a 2 litros, exceto o item classificado no CEST 17.022.00",
    "ncms": [
      "0403"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1702200",
    "descricao": "Coalhada",
    "ncms": [
      "04039000"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1702300",
    "descricao": "Requeijão e similares, em recipiente de conteúdo inferior ou igual a 1 kg, exceto as embalagens individuais de conteúdo inferior ou igual a 10 g",
    "ncms": [
      "0406"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1702301",
    "descricao": "Requeijão e similares, em recipiente de conteúdo superior a 1 kg",
    "ncms": [
      "0406"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1702400",
    "descricao": "Queijos, exceto os dos CEST 17.024.01, 17.024.02, 17.024.03 e 17.024.04",
    "ncms": [
      "0406"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1702401",
    "descricao": "Queijo muçarela",
    "ncms": [
      "04061010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1702402",
    "descricao": "Queijo minas frescal",
    "ncms": [
      "04061090"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1702403",
    "descricao": "Queijo ricota",
    "ncms": [
      "04061090"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1702404",
    "descricao": "Queijo petitsuisse",
    "ncms": [
      "04061090"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1702405",
    "descricao": "Queijo cremoso (“cream cheese”)",
    "ncms": [
      "04061090"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1702500",
    "descricao": "Manteiga, em embalagem de conteúdo inferior ou igual a 1 kg, exceto as embalagens individuais de conteúdo inferior ou igual a 10 g",
    "ncms": [
      "04051000"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1702501",
    "descricao": "Manteiga, em embalagem de conteúdo superior a 1 kg",
    "ncms": [
      "04051000"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1702502",
    "descricao": "Manteiga de garrafa",
    "ncms": [
      "04059090"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1702600",
    "descricao": "Margarina e creme vegetal em recipiente de conteúdo inferior ou igual a 500 g, exceto as embalagens individuais de conteúdo inferior ou igual a 10 g",
    "ncms": [
      "15171000"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1702700",
    "descricao": "Margarina e creme vegetal, em recipiente de conteúdo superior a 500 g e inferior ou igual a 1 kg, exceto as embalagens individuais de conteúdo inferior ou igual a 10 g",
    "ncms": [
      "15171000"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1702701",
    "descricao": "Margarina e creme vegetal, em recipiente de conteúdo superior a 1 kg",
    "ncms": [
      "15171000"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1702702",
    "descricao": "Outras margarinas e cremes vegetais em recipiente de conteúdo inferior a 1 kg, exceto as embalagens individuais de conteúdo inferior ou igual a 10 g",
    "ncms": [
      "151790"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1702800",
    "descricao": "Gorduras e óleos vegetais e respectivas frações, parcial ou totalmente hidrogenados, interesterificados, reesterificados ou elaidinizados, mesmo refinados, mas não preparados de outro modo, em recipiente de conteúdo inferior ou igual a 1 kg, exceto as embalagens individuais de conteúdo inferior ou igual a 10 g",
    "ncms": [
      "15162000"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1702801",
    "descricao": "Gorduras e óleos vegetais e respectivas frações, parcial ou totalmente hidrogenados, interesterificados, reesterificados ou elaidinizados, mesmo refinados, mas não preparados de outro modo, em recipiente de conteúdo superior a 1 kg, exceto as embalagens individuais de conteúdo inferior ou igual a 10 g",
    "ncms": [
      "15162000"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1702900",
    "descricao": "Doces de leite",
    "ncms": [
      "19019020"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1703000",
    "descricao": "Produtos à base de cereais, obtidos por expansão ou torrefação",
    "ncms": [
      "19041000"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1703100",
    "descricao": "Salgadinhos diversos, exceto os classificados no CEST 17.031.01 e 17.031.02",
    "ncms": [
      "19059090"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "1703101",
    "descricao": "Salgadinhos diversos, derivados de farinha de trigo",
    "ncms": [
      "19059090"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1703102",
    "descricao": "Biscoitos de polvilho",
    "ncms": [
      "19059090"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1703200",
    "descricao": "Batata frita, inhame e mandioca fritos",
    "ncms": [
      "20052000"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1703300",
    "descricao": "Amendoim e castanhas tipo aperitivo, em embalagem de conteúdo inferior ou igual a 1 kg",
    "ncms": [
      "20081"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1703301",
    "descricao": "Amendoim e castanhas tipo aperitivo, em embalagem de conteúdo superior a 1 kg",
    "ncms": [
      "20081"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1703400",
    "descricao": "Catchup em embalagens imediatas de conteúdo inferior ou igual a 650 g, exceto as embalagens contendo envelopes individualizados (sachês) de conteúdo inferior ou igual a 10 g",
    "ncms": [
      "21032010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1703500",
    "descricao": "Condimentos e temperos compostos, incluindo molho de pimenta e outros molhos, em embalagens imediatas de conteúdo inferior ou igual a 1 kg, exceto as embalagens contendo envelopes individualizados (sachês) de conteúdo inferior ou igual a 3 g",
    "ncms": [
      "21039021"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1703600",
    "descricao": "Molhos de soja preparados em embalagens imediatas de conteúdo inferior ou igual a 650 g, exceto as embalagens contendo envelopes individualizados (sachês) de conteúdo inferior ou igual a 10 g",
    "ncms": [
      "21031010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1703700",
    "descricao": "Farinha de mostarda em embalagens de conteúdo inferior ou igual a 1 kg",
    "ncms": [
      "21033010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1703800",
    "descricao": "Mostarda preparada em embalagens imediatas de conteúdo inferior ou igual a 650 g, exceto as embalagens contendo envelopes individualizados (sachês) de conteúdo inferior ou igual a 10 g",
    "ncms": [
      "21033021"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1703900",
    "descricao": "Maionese em embalagens imediatas de conteúdo inferior ou igual a 650 g, exceto as embalagens contendo envelopes individualizados (sachês) de conteúdo inferior ou igual a 10 g",
    "ncms": [
      "21039011"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704000",
    "descricao": "Tomates preparados ou conservados, exceto em vinagre ou em ácido acético, em embalagens de conteúdo inferior ou igual a 1 kg",
    "ncms": [
      "2002"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704100",
    "descricao": "Molhos de tomate em embalagens imediatas de conteúdo inferior ou igual a 1 kg",
    "ncms": [
      "21032010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704200",
    "descricao": "Barra de cereais",
    "ncms": [
      "17049090"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704300",
    "descricao": "Barra de cereais contendo cacau",
    "ncms": [
      "18063120"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704400",
    "descricao": "Farinha de trigo especial, em embalagem inferior ou igual a 1 kg",
    "ncms": [
      "11010010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704401",
    "descricao": "Farinha de trigo especial, em embalagem superior a 1 kg e inferior a 5 kg",
    "ncms": [
      "11010010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704402",
    "descricao": "Farinha de trigo especial, em embalagem igual a 5 kg",
    "ncms": [
      "11010010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704403",
    "descricao": "Farinha de trigo especial, em embalagem superior a 5 kg e inferior ou igual a 25 kg",
    "ncms": [
      "11010010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704404",
    "descricao": "Farinha de trigo especial, em embalagem superior a 25 kg e inferior ou igual a 50 kg",
    "ncms": [
      "11010010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704405",
    "descricao": "Farinha de trigo comum, em embalagem igual a 5 kg",
    "ncms": [
      "11010010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704406",
    "descricao": "Farinha de trigo comum, em embalagem superior a 5 kg e inferior ou igual a 25 kg",
    "ncms": [
      "11010010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704407",
    "descricao": "Farinha de trigo comum, em embalagem superior a 25 kg e inferior ou igual a 50 kg",
    "ncms": [
      "11010010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704408",
    "descricao": "Farinha de trigo doméstica especial, em embalagem superior a 5 kg e inferior e igual a 10 kg",
    "ncms": [
      "11010010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704409",
    "descricao": "Farinha de trigo doméstica com fermento, em embalagem superior a 5 kg e inferior e igual a 10 kg",
    "ncms": [
      "11010010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704410",
    "descricao": "Farinha de trigo especial, em embalagem superior a 50 Kg",
    "ncms": [
      "11010010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704411",
    "descricao": "Farinha de trigo comum, em embalagem inferior ou igual a 1 kg",
    "ncms": [
      "11010010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704412",
    "descricao": "Farinha de trigo comum, em embalagem superior a 1 kg e inferior a 5 Kg",
    "ncms": [
      "11010010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704413",
    "descricao": "Farinha de trigo comum, em embalagem superior a 50 kg",
    "ncms": [
      "11010010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704414",
    "descricao": "Farinha de trigo doméstica especial, em embalagem inferior ou igual a 1 kg",
    "ncms": [
      "11010010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704415",
    "descricao": "Farinha de trigo doméstica especial, em embalagem superior a 1 kg e inferior a 5 Kg",
    "ncms": [
      "11010010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704416",
    "descricao": "Farinha de trigo doméstica especial, em embalagem igual a 5 Kg",
    "ncms": [
      "11010010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704417",
    "descricao": "Farinha de trigo doméstica especial, em embalagem superior a 10 Kg",
    "ncms": [
      "11010010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704418",
    "descricao": "Farinha de trigo doméstica com fermento, em embalagem inferior ou igual a 1 kg",
    "ncms": [
      "11010010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704419",
    "descricao": "Farinha de trigo doméstica com fermento, em embalagem superior a 1 kg e inferior a 5 Kg",
    "ncms": [
      "11010010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704420",
    "descricao": "Farinha de trigo doméstica com fermento, em embalagem igual a 5 Kg",
    "ncms": [
      "11010010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704421",
    "descricao": "Farinha de trigo doméstica com fermento, em embalagem superior a 10 Kg",
    "ncms": [
      "11010010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704422",
    "descricao": "Outras farinhas de trigo, em embalagem inferior ou igual a 1 kg",
    "ncms": [
      "11010010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704423",
    "descricao": "Outras farinhas de trigo, em embalagem superior a 1 kg e inferior a 5 Kg",
    "ncms": [
      "11010010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704424",
    "descricao": "Outras farinhas de trigo, em embalagem igual a 5 Kg",
    "ncms": [
      "11010010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704425",
    "descricao": "Outras farinhas de trigo, em embalagem superior a 5 Kg e inferior ou igual a 25 kg",
    "ncms": [
      "11010010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704426",
    "descricao": "Outras farinhas de trigo, em embalagem superior a 25 Kg e inferior ou igual a 50 kg",
    "ncms": [
      "11010010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704427",
    "descricao": "Outras farinhas de trigo, em embalagem superior a 50 Kg",
    "ncms": [
      "11010010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704500",
    "descricao": "Farinha de mistura de trigo com centeio (méteil)",
    "ncms": [
      "11010020"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704600",
    "descricao": "Misturas e preparações para bolos, em embalagem inferior 5 kg",
    "ncms": [
      "190120"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704601",
    "descricao": "Misturas e preparações para bolos, em embalagem igual a 5 kg",
    "ncms": [
      "190120"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704602",
    "descricao": "Misturas e preparações para bolos, em embalagem superior a 5 kg e inferior ou igual a 25 Kg",
    "ncms": [
      "190120"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704603",
    "descricao": "Misturas e preparações para bolos, em embalagem superior a 25 kg e inferior ou igual a 50 Kg",
    "ncms": [
      "190120",
      "19019090",
      "19012000"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704604",
    "descricao": "Misturas e preparações para bolos, em embalagem superior a 50 Kg",
    "ncms": [
      "190120"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704605",
    "descricao": "Misturas e preparações para pães com menos de 80% de farinha de trigo na sua composição final, em embalagem inferior a 5 kg",
    "ncms": [
      "190120"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704606",
    "descricao": "Misturas e preparações para pães com menos de 80% de farinha de trigo na sua composição final, em embalagem igual a 5 kg",
    "ncms": [
      "190120"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704607",
    "descricao": "Misturas e preparações para pães com menos de 80% de farinha de trigo na sua composição final, em embalagem superior a 5 kg e inferior ou igual a 25 Kg",
    "ncms": [
      "190120"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704608",
    "descricao": "Misturas e preparações para pães com menos de 80% de farinha de trigo na sua composição final, em embalagem superior a 25 kg e inferior ou igual a 50 Kg",
    "ncms": [
      "190120"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704609",
    "descricao": "Misturas e preparações para pães com menos de 80% de farinha de trigo na sua composição final, em embalagem superior a 50 Kg",
    "ncms": [
      "190120"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704610",
    "descricao": "Misturas e preparações para pães com, no mínimo, 80% de farinha de trigo na sua composição final, em embalagem inferior a 5 kg",
    "ncms": [
      "190120"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704611",
    "descricao": "Misturas e preparações para pães com, no mínimo, 80% de farinha de trigo na sua composição final, em embalagem igual a 5 kg",
    "ncms": [
      "190120"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704612",
    "descricao": "Misturas e preparações para pães com, no mínimo, 80% de farinha de trigo na sua composição final, em embalagem superior a 5 kg e inferior ou igual a 25 Kg",
    "ncms": [
      "190120"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704613",
    "descricao": "Misturas e preparações para pães com, no mínimo, 80% de farinha de trigo na sua composição final, em embalagem superior a 25 kg e inferior ou igual a 50 Kg",
    "ncms": [
      "190120"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704614",
    "descricao": "Misturas e preparações para pães com, no mínimo, 80% de farinha de trigo na sua composição final, em embalagem superior a 50 Kg",
    "ncms": [
      "190120"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704615",
    "descricao": "Misturas e pastas para a preparação de produtos de padaria, pastelaria e da indústria de bolachas e biscoitos, da posição 19.05, exceto os previstos nos CEST 17.046.00 a 17.046.14 e 17.046.16.",
    "ncms": [
      "190120",
      "19019090"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704616",
    "descricao": "Misturas e preparações com, no mínimo, 80% de farinha de trigo na sua composição final, exceto as descritas nos CEST 17.046.10 a 17.046.15.",
    "ncms": [
      "190120",
      "19019090"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704700",
    "descricao": "Massas alimentícias tipo instantânea, exceto as descritas no CEST 17047.01.",
    "ncms": [
      "19023000"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704701",
    "descricao": "Massas alimentícias tipo instantânea, derivadas de farinha de trigo.",
    "ncms": [
      "19023000"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704800",
    "descricao": "Massas alimentícias, cozidas ou recheadas (de carne ou de outras substâncias) ou preparadas de outro modo, exceto as descritas nos CEST 17.047.00, 17.048.01, e 17.048.02",
    "ncms": [
      "1902"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704801",
    "descricao": "Cuscuz",
    "ncms": [
      "19024000"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704802",
    "descricao": "Massas alimentícias recheadas (mesmo cozidas ou preparadas de outro modo)",
    "ncms": [
      "19022000"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704900",
    "descricao": "Massas alimentícias do tipo comum, não cozidas, nem recheadas, nem preparadas de outro modo, não derivadas do trigo",
    "ncms": [
      "19021"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704901",
    "descricao": "Massas alimentícias do tipo sêmola, não cozidas, nem recheadas, nem preparadas de outro modo, não derivadas do trigo",
    "ncms": [
      "19021"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704902",
    "descricao": "Massas alimentícias do tipo grano duro, não cozidas, nem recheadas, nem preparadas de outro modo, que contenham ovos",
    "ncms": [
      "19021100"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704903",
    "descricao": "Outras massas alimentícias do tipo comum, não cozidas, nem recheadas, nem preparadas de outro modo, que não contenham ovos, derivadas de farinha de trigo",
    "ncms": [
      "19021900"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704904",
    "descricao": "Outras massas alimentícias do tipo sêmola, não cozidas, nem recheadas, nem preparadas de outro modo, que não contenham ovos, derivadas do trigo",
    "ncms": [
      "19021900"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704905",
    "descricao": "Outras massas alimentícias do tipo grano duro, não cozidas, nem recheadas, nem preparadas de outro modo, que não contenham ovos",
    "ncms": [
      "19021900"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704906",
    "descricao": "Massas alimentícias do tipo comum, não cozidas, nem recheadas, nem preparadas de outro modo, que contenham ovos, derivadas de farinha de trigo",
    "ncms": [
      "19021100"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704907",
    "descricao": "Massas alimentícias do tipo sêmola, não cozidas, nem recheadas, nem preparadas de outro modo, que contenham ovos, derivadas do trigo",
    "ncms": [
      "19021100"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1704908",
    "descricao": "REVOGADO",
    "ncms": [
      "19021900"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "1704909",
    "descricao": "REVOGADO",
    "ncms": [
      "19021900"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "1705000",
    "descricao": "Pães industrializados, inclusive de especiarias, exceto panetones e bolo de forma",
    "ncms": [
      "190520"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1705100",
    "descricao": "Bolo de forma, inclusive de especiarias",
    "ncms": [
      "19052090"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1705200",
    "descricao": "Panetones",
    "ncms": [
      "19052010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1705300",
    "descricao": "Biscoitos e bolachas derivados de farinha de trigo; (exceto dos tipos “cream cracker”, “água e sal”, “maisena”, “maria” e outros de consumo popular que não sejam adicionados de cacau, nem recheados, cobertos ou amanteigados, independentemente de sua denominação comercial)",
    "ncms": [
      "19053100"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1705301",
    "descricao": "Biscoitos e bolachas derivados de farinha de trigo dos tipos “maisena” e “maria” e outros de consumo popular que não sejam adicionados de cacau, nem recheados, cobertos ou amanteigados, independentemente de sua denominação comercial, exceto o CEST 17.053.02",
    "ncms": [
      "19053100"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1705302",
    "descricao": "Biscoitos e bolachas derivados de farinha de trigo dos tipos \"cream cracker\" e \"água e sal\" de consumo popular",
    "ncms": [
      "19053100"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1705400",
    "descricao": "Biscoitos e bolachas não derivados de farinha de trigo; (exceto dos tipos \"cream cracker\", \"água e sal\", \"maisena\" e \"maria\" e outros de consumo popular que não sejam adicionados de cacau, nem recheados, cobertos ou amanteigados, independentemente de sua denominação comercial)",
    "ncms": [
      "19053100"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1705401",
    "descricao": "Biscoitos e bolachas não derivados de farinha de trigo dos tipos \"maisena\" e \"maria\" e outros de consumo popular que não sejam adicionados de cacau, nem recheados, cobertos ou amanteigados, independentemente de sua denominação comercial, exceto o CEST 17.054.02",
    "ncms": [
      "19053100"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1705402",
    "descricao": "Biscoitos e bolachas não derivados de farinha de trigo dos tipos \"cream cracker\" e \"água e sal\" de consumo popular",
    "ncms": [
      "19053100"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1705600",
    "descricao": "Biscoitos e bolachas derivados de farinha de trigo dos tipos “cream cracker” e “água e sal”",
    "ncms": [
      "19059020"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1705601",
    "descricao": "Biscoitos e bolachas não derivados de farinha de trigo dos tipos “cream cracker” e “água e sal”",
    "ncms": [
      "19059020"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1705602",
    "descricao": "Outras bolachas, exceto casquinhas para sorvete e os biscoitos e bolachas relacionados nos CEST 17.056.00 e 17.056.01",
    "ncms": [
      "19059020"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1705700",
    "descricao": "“Waffles” e “wafers” - sem cobertura",
    "ncms": [
      "19053200"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1705800",
    "descricao": "“Waffles” e “wafers” - com cobertura",
    "ncms": [
      "19053200"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1705900",
    "descricao": "Torradas, pão torrado e produtos semelhantes torrados",
    "ncms": [
      "19054000"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1706000",
    "descricao": "Outros pães de forma",
    "ncms": [
      "19059010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1706200",
    "descricao": "Outros pães, exceto o classificado no CEST 17.062.03",
    "ncms": [
      "19059090"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1706201",
    "descricao": "Outros bolos industrializados e produtos de panificação não especificados anteriormente, incluindo as pizzas; exceto os classificados nos CEST 17.062.02 e 17.062.03",
    "ncms": [
      "19059090"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1706202",
    "descricao": "Casquinhas para sorvete",
    "ncms": [
      "19059020",
      "19059090"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1706203",
    "descricao": "Pão francês até 200g",
    "ncms": [
      "19059090"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1706300",
    "descricao": "Pão denominado knackebrot",
    "ncms": [
      "19051000"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1706400",
    "descricao": "Demais pães industrializados",
    "ncms": [
      "190590"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1706500",
    "descricao": "Óleo de soja refinado, em recipientes com capacidade inferior ou igual a 5 litros, exceto as embalagens individuais de conteúdo inferior ou igual a 15 mililitros",
    "ncms": [
      "15079011"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1706600",
    "descricao": "Óleo de amendoim refinado, em recipientes com capacidade inferior ou igual a 5 litros, exceto as embalagens individuais de conteúdo inferior ou igual a 15 mililitros",
    "ncms": [
      "1508"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1706700",
    "descricao": "Azeites de oliva, em recipientes com capacidade inferior a 2 litros, exceto as embalagens individuais de conteúdo inferior ou igual a 20 mililitros",
    "ncms": [
      "1509"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1706701",
    "descricao": "Azeites de oliva, em recipientes com capacidade igual ou superior a 2 litros e inferior ou igual a 5 litros",
    "ncms": [
      "1509"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1706702",
    "descricao": "Azeites de oliva, em recipientes com capacidade superior a 5 litros",
    "ncms": [
      "1509"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1706800",
    "descricao": "Outros óleos e respectivas frações, obtidos exclusivamente a partir de azeitonas, mesmo refinados, mas não quimicamente modificados, e misturas desses óleos ou frações com óleos ou frações da posição 15.09, em recipientes com capacidade inferior ou igual a 5 litros, exceto as embalagens individuais de conteúdo inferior ou igual a 15 mililitros",
    "ncms": [
      "1510"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1706900",
    "descricao": "Óleo de girassol em recipientes com capacidade inferior ou igual a 5 litros, exceto as embalagens individuais de conteúdo inferior ou igual a 15 mililitros",
    "ncms": [
      "15121911"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1706901",
    "descricao": "Óleo de algodão refinado em recipientes com capacidade inferior ou igual a 5 litros, exceto as embalagens individuais de conteúdo inferior ou igual a 15 mililitros",
    "ncms": [
      "15122910"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1707000",
    "descricao": "Óleo de canola, em recipientes com capacidade inferior ou igual a 5 litros, exceto as embalagens individuais de conteúdo inferior ou igual a 15 mililitros",
    "ncms": [
      "15141"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1707100",
    "descricao": "Óleo de linhaça refinado, em recipientes com capacidade inferior ou igual a 5 litros, exceto as embalagens individuais de conteúdo inferior ou igual a 15 mililitros",
    "ncms": [
      "15151900"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1707200",
    "descricao": "Óleo de milho refinado, em recipientes com capacidade inferior ou igual a 5 litros, exceto as embalagens individuais de conteúdo inferior ou igual a 15 mililitros",
    "ncms": [
      "15152910"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1707300",
    "descricao": "Outros óleos refinados, em recipientes com capacidade inferior ou igual a 5 litros, exceto as embalagens individuais de conteúdo inferior ou igual a 15 mililitros",
    "ncms": [
      "15122990"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1707400",
    "descricao": "Misturas de óleos refinados, para consumo humano, em recipientes com capacidade inferior ou igual a 5 litros, exceto as embalagens individuais de conteúdo inferior ou igual a 15 mililitros",
    "ncms": [
      "15179010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1707500",
    "descricao": "Outros óleos vegetais comestíveis não especificados anteriormente",
    "ncms": [
      "1511"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1707600",
    "descricao": "Enchidos (embutidos) e produtos semelhantes, de carne, miudezas ou sangue; exceto salsicha, linguiça e mortadela",
    "ncms": [
      "16010000"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1707700",
    "descricao": "Salsicha e linguiça, exceto as descritas nos CEST 17.077.01",
    "ncms": [
      "16010000"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1707701",
    "descricao": "Salsicha em lata",
    "ncms": [
      "16010000"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1707800",
    "descricao": "Mortadela",
    "ncms": [
      "16010000"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1707900",
    "descricao": "Outras preparações e conservas de carne, miudezas ou de sangue, exceto as descritas nos CEST 17.079.01, 17.079.02, 17.079.03, 17.079.04, 17.079.05, 17.079.06, 17.079.07 e 17.079.08",
    "ncms": [
      "1602"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1707901",
    "descricao": "Outras preparações e conservas de carne, de miudezas ou de sangue, de aves da posição 01.05: de peruas e de perus, exceto as descritas no CEST 17.079.08",
    "ncms": [
      "16023100"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1707902",
    "descricao": "Outras preparações e conservas de carne, de miudezas ou de sangue, de aves da posição 01.05: de galos e de galinhas, com conteúdo de carne ou de miudezas superior ou igual a 57 %, em peso, não cozidas, exceto as descritas no CEST 17.079.08",
    "ncms": [
      "16023210"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1707903",
    "descricao": "Outras preparações e conservas de carne, de miudezas ou de sangue, de aves da posição 01.05: de galos e de galinhas, com conteúdo de carne ou de miudezas superior ou igual a 57 %, em peso, cozidas, exceto as descritas no CEST 17.079.08",
    "ncms": [
      "16023220"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1707904",
    "descricao": "Outras preparações e conservas de carne, de miudezas ou de sangue, da espécie suína: pernas e respectivos pedaços",
    "ncms": [
      "16024100"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1707905",
    "descricao": "Outras preparações e conservas de carne, de miudezas ou de sangue, da espécie suína: outras, incluindo as misturas, exceto os descritos no CEST 17.079.07",
    "ncms": [
      "16024900"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1707906",
    "descricao": "Outras preparações e conservas de carne, de miudezas ou de sangue, da espécie bovina",
    "ncms": [
      "16025000"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1707907",
    "descricao": "Apresuntado",
    "ncms": [
      "16024900"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1707908",
    "descricao": "Carnes de aves inteiras e com peso unitário superior a 3 kg, temperadas",
    "ncms": [
      "160231"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1708000",
    "descricao": "Preparações e conservas de peixes; caviar e seus sucedâneos preparados a partir de ovas de peixe; exceto os descritos nos CEST 17.080.01 e 17.081.00",
    "ncms": [
      "1604"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1708001",
    "descricao": "Outras preparações e conservas de atuns",
    "ncms": [
      "16042010"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1708100",
    "descricao": "Sardinha em conserva",
    "ncms": [
      "1604"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1708200",
    "descricao": "Crustáceos, moluscos e outros invertebrados aquáticos, preparados ou em conservas",
    "ncms": [
      "1605"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1708300",
    "descricao": "Carne de gado bovino, ovino e bufalino e produtos comestíveis resultantes da matança desse gado submetidos à salga, secagem ou desidratação, exceto os descritos no CEST 17.083.01",
    "ncms": [
      "02102000"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1708301",
    "descricao": "Charque e jerkedbeef",
    "ncms": [
      "02102000"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1708400",
    "descricao": "Carne de gado bovino, ovino e bufalino e demais produtos comestíveis resultantes da matança desse gado frescos, refrigerados ou congelados",
    "ncms": [
      "0201"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1708500",
    "descricao": "Carnes de animais das espécies caprina, frescas, refrigeradas ou congeladas",
    "ncms": [
      "0204"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1708600",
    "descricao": "Carnes e demais produtos comestíveis frescos, resfriados, congelados, salgados ou salmourados resultantes do abate de caprinos",
    "ncms": [
      "02109900"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1708700",
    "descricao": "Carnes e demais produtos comestíveis frescos, resfriados, congelados, salgados, em salmoura, simplesmente temperados, secos ou defumados, resultantes do abate de aves, exceto os descritos no CEST 17.087.02",
    "ncms": [
      "0207"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1708701",
    "descricao": "Carnes e demais produtos comestíveis frescos, resfriados, congelados, salgados, em salmoura, simplesmente temperados, secos ou defumados, resultantes do abate de suínos",
    "ncms": [
      "0203"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1708702",
    "descricao": "Carnes de aves inteiras e com peso unitário superior a 3 kg",
    "ncms": [
      "02071"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1708800",
    "descricao": "Produtos hortícolas, cozidos em água ou vapor, congelados, em embalagens de conteúdo inferior ou igual a 1 kg",
    "ncms": [
      "0710"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1708801",
    "descricao": "Produtos hortícolas, cozidos em água ou vapor, congelados, em embalagens de conteúdo superior a 1 kg",
    "ncms": [
      "0710"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1708900",
    "descricao": "Frutas, não cozidas ou cozidas em água ou vapor, congeladas, mesmo adicionadas de açúcar ou de outros edulcorantes, em embalagens de conteúdo inferior ou igual a 1 kg",
    "ncms": [
      "0811"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1708901",
    "descricao": "Frutas, não cozidas ou cozidas em água ou vapor, congeladas, mesmo adicionadas de açúcar ou de outros edulcorantes, em embalagens de conteúdo superior a 1 kg",
    "ncms": [
      "0811"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1709000",
    "descricao": "Produtos hortícolas, frutas e outras partes comestíveis de plantas, preparados ou conservados em vinagre ou em ácido acético, em embalagens de conteúdo inferior ou igual a 1 kg",
    "ncms": [
      "2001"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1709001",
    "descricao": "Produtos hortícolas, frutas e outras partes comestíveis de plantas, preparados ou conservados em vinagre ou em ácido acético, em embalagens de conteúdo superior a 1 kg",
    "ncms": [
      "2001"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1709100",
    "descricao": "Outros produtos hortícolas preparados ou conservados, exceto em vinagre ou em ácido acético, congelados, com exceção dos produtos da posição 20.06, em embalagens de conteúdo inferior ou igual a 1 kg",
    "ncms": [
      "2004"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1709101",
    "descricao": "Outros produtos hortícolas preparados ou conservados, exceto em vinagre ou em ácido acético, congelados, com exceção dos produtos da posição 20.06, em embalagens de conteúdo superior a 1 kg",
    "ncms": [
      "2004"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1709200",
    "descricao": "Outros produtos hortícolas preparados ou conservados, exceto em vinagre ou em ácido acético, não congelados, com exceção dos produtos da posição 20.06, excluídos batata, inhame e mandioca fritos, em embalagens de conteúdo inferior ou igual a 1 kg",
    "ncms": [
      "2005"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1709201",
    "descricao": "Outros produtos hortícolas preparados ou conservados, exceto em vinagre ou em ácido acético, não congelados, com exceção dos produtos da posição 20.06, excluídos batata, inhame e mandioca fritos, em embalagens de conteúdo superior a 1 kg",
    "ncms": [
      "2005"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1709300",
    "descricao": "Produtos hortícolas, frutas, cascas de frutas e outras partes de plantas, conservados com açúcar (passados por calda, glaceados ou cristalizados), em embalagens de conteúdo inferior ou igual a 1 kg",
    "ncms": [
      "20060000"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1709301",
    "descricao": "Produtos hortícolas, frutas, cascas de frutas e outras partes de plantas, conservados com açúcar (passados por calda, glaceados ou cristalizados), em embalagens de conteúdo superior a 1 kg",
    "ncms": [
      "20060000"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1709400",
    "descricao": "Doces, geleias, “marmelades”, purês e pastas de frutas, obtidos por cozimento, com ou sem adição de açúcar ou de outros edulcorantes, em embalagens de conteúdo inferior ou igual a 1 kg, exceto as embalagens individuais de conteúdo inferior ou igual a 10 g",
    "ncms": [
      "2007"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1709401",
    "descricao": "Doces, geleias, “marmelades”, purês e pastas de frutas, obtidos por cozimento, com ou sem adição de açúcar ou de outros edulcorantes, em embalagens de conteúdo superior a 1 kg",
    "ncms": [
      "2007"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1709500",
    "descricao": "Frutas e outras partes comestíveis de plantas, preparadas ou conservadas de outro modo, com ou sem adição de açúcar ou de outros edulcorantes ou de álcool, não especificadas nem compreendidas em outras posições, excluídos os amendoins e castanhas tipo aperitivo, da posição 2008.1, em embalagens de conteúdo inferior ou igual a 1 kg",
    "ncms": [
      "2008"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1709501",
    "descricao": "Frutas e outras partes comestíveis de plantas, preparadas ou conservadas de outro modo, com ou sem adição de açúcar ou de outros edulcorantes ou de álcool, não especificadas nem compreendidas em outras posições, excluídos os amendoins e castanhas tipo aperitivo, da posição 2008.1, em embalagens superior a 1 kg",
    "ncms": [
      "2008"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1709600",
    "descricao": "Café torrado e moído, em embalagens de conteúdo inferior ou igual a 2 kg, exceto os classificados nos CEST 17.096.04 e 17.096.05",
    "ncms": [
      "0901"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1709601",
    "descricao": "Café torrado e moído, em embalagens de conteúdo superior a 2 kg",
    "ncms": [
      "0901"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1709602",
    "descricao": "Café torrado em grão, em embalagens de conteúdo inferior ou igual a 2 kg",
    "ncms": [
      "0901"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1709603",
    "descricao": "Café torrado em grão, em embalagens de conteúdo superior a 2 kg",
    "ncms": [
      "0901"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1709604",
    "descricao": "Café torrado e moído, em cápsulas, exceto os descritos no CEST 17.096.05",
    "ncms": [
      "0901"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1709605",
    "descricao": "Café descafeinado torrado e moído, em cápsulas",
    "ncms": [
      "0901"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1709700",
    "descricao": "Chá, mesmo aromatizado",
    "ncms": [
      "0902"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1709800",
    "descricao": "Mate",
    "ncms": [
      "090300"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1709900",
    "descricao": "Açúcar refinado, em embalagens de conteúdo inferior ou igual a 2 kg, exceto as embalagens contendo envelopes individualizados (sachês) de conteúdo inferior ou igual a 10 g",
    "ncms": [
      "17011"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1709901",
    "descricao": "Açúcar refinado, em embalagens de conteúdo superior a 2 kg e inferior ou igual a 5 kg",
    "ncms": [
      "17011"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1709902",
    "descricao": "Açúcar refinado, em embalagens de conteúdo superior a 5 kg",
    "ncms": [
      "17011"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1710000",
    "descricao": "Açúcar refinado adicionado de aromatizante ou de corante em embalagens de conteúdo inferior ou igual a 2 kg, exceto as embalagens contendo envelopes individualizados (sachês) de conteúdo inferior ou igual a 10 g",
    "ncms": [
      "17019100"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1710001",
    "descricao": "Açúcar refinado adicionado de aromatizante ou de corante em embalagens de conteúdo superior a 2 kg e inferior ou igual a 5 kg",
    "ncms": [
      "17019100"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1710002",
    "descricao": "Açúcar refinado adicionado de aromatizante ou de corante em embalagens de conteúdo superior a 5 kg",
    "ncms": [
      "17019100"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1710100",
    "descricao": "Açúcar cristal, em embalagens de conteúdo inferior ou igual a 2 kg, exceto as embalagens contendo envelopes individualizados (sachês) de conteúdo inferior ou igual a 10 g",
    "ncms": [
      "17011"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1710101",
    "descricao": "Açúcar cristal, em embalagens de conteúdo superior a 2 kg e inferior ou igual a 5 kg",
    "ncms": [
      "17011"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1710102",
    "descricao": "Açúcar cristal, em embalagens de conteúdo superior a 5 kg",
    "ncms": [
      "17011"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1710200",
    "descricao": "Açúcar cristal adicionado de aromatizante ou de corante, em embalagens de conteúdo inferior ou igual a 2 kg, exceto as embalagens contendo envelopes individualizados (sachês) de conteúdo inferior ou igual a 10 g",
    "ncms": [
      "17019100"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1710201",
    "descricao": "Açúcar cristal adicionado de aromatizante ou de corante, em embalagens de conteúdo superior a 2 kg e inferior ou igual a 5 kg",
    "ncms": [
      "17019100"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1710202",
    "descricao": "Açúcar cristal adicionado de aromatizante ou de corante, em embalagens de conteúdo superior a 5 kg",
    "ncms": [
      "170191"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1710300",
    "descricao": "Outros tipos de açúcar, em embalagens de conteúdo inferior ou igual a 2 kg, exceto as embalagens contendo envelopes individualizados (sachês) de conteúdo inferior ou igual a 10 g",
    "ncms": [
      "17011"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1710301",
    "descricao": "Outros tipos de açúcar, em embalagens de conteúdo superior a 2 kg e inferior ou igual a 5 kg",
    "ncms": [
      "17011"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1710302",
    "descricao": "Outros tipos de açúcar, em embalagens de conteúdo superior a 5 kg",
    "ncms": [
      "17011"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1710400",
    "descricao": "Outros tipos de açúcar adicionado de aromatizante ou de corante, em embalagens de conteúdo inferior ou igual a 2 kg, exceto as embalagens contendo envelopes individualizados (sachês) de conteúdo inferior ou igual a 10 g",
    "ncms": [
      "17019100"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1710401",
    "descricao": "Outros tipos de açúcar adicionado de aromatizante ou de corante, em embalagens de conteúdo superior a 2 kg e inferior ou igual a 5 kg",
    "ncms": [
      "17019100"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1710402",
    "descricao": "Outros tipos de açúcar adicionado de aromatizante ou de corante, em embalagens de conteúdo superior a 5 kg",
    "ncms": [
      "17019100"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1710500",
    "descricao": "Outros açúcares em embalagens de conteúdo inferior ou igual a 2 kg, exceto as embalagens contendo envelopes individualizados (sachês) de conteúdo inferior ou igual a 10 g",
    "ncms": [
      "1702"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1710501",
    "descricao": "Outros açúcares, em embalagens de conteúdo superior a 2 kg e inferior ou igual a 5 kg",
    "ncms": [
      "1702"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1710502",
    "descricao": "Outros açúcares, em embalagens de conteúdo superior a 5 kg",
    "ncms": [
      "1702"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1710600",
    "descricao": "Milho para pipoca (micro-ondas)",
    "ncms": [
      "20081900"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1710700",
    "descricao": "Extratos, essências e concentrados de café e preparações à base destes extratos, essências ou concentrados ou à base de café, em embalagens de conteúdo inferior ou igual a 500 g, exceto os classificados no CEST 17.107.01",
    "ncms": [
      "21011"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1710701",
    "descricao": "Extratos, essências e concentrados de café e preparações à base destes extratos, essências ou concentrados ou à base de café, em cápsulas",
    "ncms": [
      "21011"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1710800",
    "descricao": "Extratos, essências e concentrados de chá ou de mate e preparações à base destes extratos, essências ou concentrados ou à base de chá ou de mate, em embalagens de conteúdo inferior ou igual a 500 g, exceto as bebidas prontas à base de mate ou chá e os itens classificados no CEST 17.108.01",
    "ncms": [
      "210120"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1710801",
    "descricao": "Extratos, essências e concentrados de chá ou de mate e preparações à base destes extratos, essências ou concentrados ou à base de chá ou de mate, em cápsulas",
    "ncms": [
      "210120"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1711000",
    "descricao": "Refrescos e outras bebidas prontas para beber, à base de chá e mate",
    "ncms": [
      "22021000"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1711100",
    "descricao": "Refrescos e outras bebidas não alcoólicas, exceto os refrigerantes e as demais bebidas nos CEST 03.007.00 e 17.110.00",
    "ncms": [
      "22021000"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1711200",
    "descricao": "Néctares de frutas e outras bebidas não alcoólicas prontas para beber, exceto bebidas hidroeletrolíticas e energéticos",
    "ncms": [
      "22029900"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1711300",
    "descricao": "Bebidas prontas à base de mate ou chá",
    "ncms": [
      "210120"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1711400",
    "descricao": "Bebidas prontas à base de café",
    "ncms": [
      "22029900"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1711500",
    "descricao": "Bebidas alimentares prontas à base de soja, leite ou cacau, inclusive os produtos denominados bebidas lácteas",
    "ncms": [
      "22029900"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1711600",
    "descricao": "Sementes de anis (erva-doce), badiana (anis-estrelado), funcho, coentro, cominho ou alcaravia; bagas de zimbro; fruta seca, misturas de fruta seca ou de fruta de casa rija; quando acondicionadas em saquinhos, especialmente, para a preparação de infusões ou de tisanas (“chás”)",
    "ncms": [
      "00813"
    ],
    "segmento": "PRODUTOS ALIMENTÍCIOS"
  },
  {
    "codigo": "1900100",
    "descricao": "Tinta guache",
    "ncms": [
      "32131000"
    ],
    "segmento": "PRODUTOS DE PAPELARIA"
  },
  {
    "codigo": "1900200",
    "descricao": "Espiral - perfil para encadernação, de plástico e outros materiais classificados nas posições 3901 a 3914",
    "ncms": [
      "39162000"
    ],
    "segmento": "PRODUTOS DE PAPELARIA"
  },
  {
    "codigo": "1900300",
    "descricao": "Outros espirais - perfil para encadernação, de plástico e outros materiais classificados nas posições 3901 a 3914",
    "ncms": [
      "39161000"
    ],
    "segmento": "PRODUTOS DE PAPELARIA"
  },
  {
    "codigo": "1900400",
    "descricao": "Artigos de escritório e artigos escolares de plástico e outros materiais classificados nas posições 3901 a 3914, exceto estojos",
    "ncms": [
      "39261000"
    ],
    "segmento": "PRODUTOS DE PAPELARIA"
  },
  {
    "codigo": "1900500",
    "descricao": "Maletas e pastas para documentos e de estudante, e artefatos semelhantes",
    "ncms": [
      "42021"
    ],
    "segmento": "PRODUTOS DE PAPELARIA"
  },
  {
    "codigo": "1900501",
    "descricao": "Baús, malas e maletas para viagem",
    "ncms": [
      "42021"
    ],
    "segmento": "PRODUTOS DE PAPELARIA"
  },
  {
    "codigo": "1900600",
    "descricao": "Prancheta de plástico",
    "ncms": [
      "39269090"
    ],
    "segmento": "PRODUTOS DE PAPELARIA"
  },
  {
    "codigo": "1900700",
    "descricao": "Bobina para fax",
    "ncms": [
      "48022090"
    ],
    "segmento": "PRODUTOS DE PAPELARIA"
  },
  {
    "codigo": "1900800",
    "descricao": "Papel seda",
    "ncms": [
      "4802549"
    ],
    "segmento": "PRODUTOS DE PAPELARIA"
  },
  {
    "codigo": "1900900",
    "descricao": "Bobina para máquina de calcular, PDV ou equipamentos similares",
    "ncms": [
      "48025499"
    ],
    "segmento": "PRODUTOS DE PAPELARIA"
  },
  {
    "codigo": "1901000",
    "descricao": "Cartolina escolar e papel cartão, brancos e coloridos, cortados em folhas em que um lado seja inferior ou igual a 500 mm e o outro inferior ou igual a 700 mm, quando não dobradas, e peso igual ou superior a 120g/m²; recados autoadesivos (LP note); papéis de presente; todos cortados em tamanho pronto para uso escolar e doméstico",
    "ncms": [
      "4802569"
    ],
    "segmento": "PRODUTOS DE PAPELARIA"
  },
  {
    "codigo": "1901100",
    "descricao": "Papel fotográfico, exceto: (i) os papéis fotográficos emulsionados com haleto de prata tipo brilhante, matte ou lustre, em rolo e, com largura igual ou superior a 102 mm e comprimento inferior ou igual a 350 m, (ii) os papéis fotográficos emulsionados com haleto de prata tipo brilhante ou fosco, em folha e com largura igual ou superior a 152 mm e comprimento inferior ou igual a 307 mm, (iii) papel de qualidade fotográfica com tecnologia “Thermo-autochrome”, que submetido a um processo de aquecimento seja capaz de formar imagens por reação química e combinação das camadas cyan, magenta e amarela",
    "ncms": [
      "37031010"
    ],
    "segmento": "PRODUTOS DE PAPELARIA"
  },
  {
    "codigo": "1901200",
    "descricao": "Papel almaço",
    "ncms": [
      "48101390"
    ],
    "segmento": "PRODUTOS DE PAPELARIA"
  },
  {
    "codigo": "1901300",
    "descricao": "Papel hectográfico",
    "ncms": [
      "48169010"
    ],
    "segmento": "PRODUTOS DE PAPELARIA"
  },
  {
    "codigo": "1901400",
    "descricao": "Papel celofane e tipo celofane",
    "ncms": [
      "39202019"
    ],
    "segmento": "PRODUTOS DE PAPELARIA"
  },
  {
    "codigo": "1901500",
    "descricao": "Papel impermeável",
    "ncms": [
      "48062000"
    ],
    "segmento": "PRODUTOS DE PAPELARIA"
  },
  {
    "codigo": "1901600",
    "descricao": "Papel crepon",
    "ncms": [
      "48081000"
    ],
    "segmento": "PRODUTOS DE PAPELARIA"
  },
  {
    "codigo": "1901700",
    "descricao": "Papel fantasia",
    "ncms": [
      "48102290"
    ],
    "segmento": "PRODUTOS DE PAPELARIA"
  },
  {
    "codigo": "1901800",
    "descricao": "Papel-carbono, papel autocopiativo (exceto os vendidos em rolos de diâmetro igual ou superior a 60 cm e os vendidos em folhas de formato igual ou superior a 60 cm de altura e igual ou superior a 90 cm de largura) e outros papéis para cópia ou duplicação (incluídos os papéis para estênceis ou para chapas ofsete), estênceis completos e chapas ofsete, de papel, em folhas, mesmo acondicionados em caixas",
    "ncms": [
      "4809"
    ],
    "segmento": "PRODUTOS DE PAPELARIA"
  },
  {
    "codigo": "1901900",
    "descricao": "Envelopes, aerogramas, bilhetes-postais não ilustrados e cartões para correspondência, de papel ou cartão, caixas, sacos e semelhantes, de papel ou cartão, contendo um sortido de artigos para correspondência",
    "ncms": [
      "4817"
    ],
    "segmento": "PRODUTOS DE PAPELARIA"
  },
  {
    "codigo": "1902000",
    "descricao": "Livros de registro e de contabilidade, blocos de notas, de encomendas, de recibos, de apontamentos, de papel para cartas, agendas e artigos semelhantes",
    "ncms": [
      "48201000"
    ],
    "segmento": "PRODUTOS DE PAPELARIA"
  },
  {
    "codigo": "1902100",
    "descricao": "Cadernos",
    "ncms": [
      "48202000"
    ],
    "segmento": "PRODUTOS DE PAPELARIA"
  },
  {
    "codigo": "1902200",
    "descricao": "Classificadores, capas para encadernação (exceto as capas para livros) e capas de processos",
    "ncms": [
      "48203000"
    ],
    "segmento": "PRODUTOS DE PAPELARIA"
  },
  {
    "codigo": "1902300",
    "descricao": "Formulários em blocos tipo “manifold”, mesmo com folhas intercaladas de papel-carbono",
    "ncms": [
      "48204000"
    ],
    "segmento": "PRODUTOS DE PAPELARIA"
  },
  {
    "codigo": "1902400",
    "descricao": "Álbuns para amostras ou para coleções",
    "ncms": [
      "48205000"
    ],
    "segmento": "PRODUTOS DE PAPELARIA"
  },
  {
    "codigo": "1902500",
    "descricao": "Pastas para documentos, outros artigos escolares, de escritório ou de papelaria, de papel ou cartão e capas para livros, de papel ou cartão",
    "ncms": [
      "48209000"
    ],
    "segmento": "PRODUTOS DE PAPELARIA"
  },
  {
    "codigo": "1902600",
    "descricao": "Cartões postais impressos ou ilustrados, cartões impressos com votos ou mensagens pessoais, mesmo ilustrados, com ou sem envelopes, guarnições ou aplicações (conhecidos como cartões de expressão social - de época/sentimento)",
    "ncms": [
      "49090000"
    ],
    "segmento": "PRODUTOS DE PAPELARIA"
  },
  {
    "codigo": "1902700",
    "descricao": "Canetas esferográficas",
    "ncms": [
      "96081000"
    ],
    "segmento": "PRODUTOS DE PAPELARIA"
  },
  {
    "codigo": "1902800",
    "descricao": "Canetas e marcadores, com ponta de feltro ou com outras pontas porosas",
    "ncms": [
      "96082000"
    ],
    "segmento": "PRODUTOS DE PAPELARIA"
  },
  {
    "codigo": "1902900",
    "descricao": "Canetas tinteiro",
    "ncms": [
      "96083000"
    ],
    "segmento": "PRODUTOS DE PAPELARIA"
  },
  {
    "codigo": "1903000",
    "descricao": "Outras canetas; sortidos de canetas",
    "ncms": [
      "9608"
    ],
    "segmento": "PRODUTOS DE PAPELARIA"
  },
  {
    "codigo": "1903100",
    "descricao": "Papel cortado “cutsize” (tipo A3, A4, ofício I e II, carta e outros)",
    "ncms": [
      "480256"
    ],
    "segmento": "PRODUTOS DE PAPELARIA"
  },
  {
    "codigo": "1903200",
    "descricao": "Papel camurça",
    "ncms": [
      "52105990"
    ],
    "segmento": "PRODUTOS DE PAPELARIA"
  },
  {
    "codigo": "1903300",
    "descricao": "Papel laminado e papel espelho",
    "ncms": [
      "76071190"
    ],
    "segmento": "PRODUTOS DE PAPELARIA"
  },
  {
    "codigo": "2000100",
    "descricao": "Henna (embalagens de conteúdo inferior ou igual a 200 g)",
    "ncms": [
      "12119090"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2000101",
    "descricao": "Henna (embalagens de conteúdo superior a 200 g)",
    "ncms": [
      "12119090"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2000200",
    "descricao": "Vaselina",
    "ncms": [
      "27121000"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2000300",
    "descricao": "Amoníaco em solução aquosa (amônia)",
    "ncms": [
      "28142000"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2000400",
    "descricao": "Peróxido de hidrogênio, em embalagens de conteúdo inferior ou igual a 500 ml",
    "ncms": [
      "28470000"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2000500",
    "descricao": "Lubrificação íntima",
    "ncms": [
      "30067000"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2000600",
    "descricao": "Óleos essenciais (desterpenados ou não), incluídos os chamados “concretos” ou “absolutos”; resinoides; oleorresinas de extração; soluções concentradas de óleos essenciais em gorduras, em óleos fixos, em ceras ou em matérias análogas, obtidas por tratamento de flores através de substâncias gordas ou por maceração; subprodutos terpênicos residuais da desterpenação dos óleos essenciais; águas destiladas aromáticas e soluções aquosas de óleos essenciais, em embalagens de conteúdo inferior ou igual a 500 ml",
    "ncms": [
      "3301"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2000700",
    "descricao": "Perfumes (extratos)",
    "ncms": [
      "33030010"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2000800",
    "descricao": "Águas-de-colônia",
    "ncms": [
      "33030020"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2000900",
    "descricao": "Produtos de maquilagem para os lábios",
    "ncms": [
      "33041000"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2001000",
    "descricao": "Sombra, delineador, lápis para sobrancelhas e rímel",
    "ncms": [
      "33042010"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2001100",
    "descricao": "Outros produtos de maquilagem para os olhos",
    "ncms": [
      "33042090"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2001200",
    "descricao": "Preparações para manicuros e pedicuros, incluindo removedores de esmalte à base de acetona",
    "ncms": [
      "33043000"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2001300",
    "descricao": "Pós, incluídos os compactos",
    "ncms": [
      "33049100"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2001400",
    "descricao": "Cremes de beleza, cremes nutritivos e loções tônicas",
    "ncms": [
      "33049910"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2001500",
    "descricao": "Outros produtos de beleza ou de maquilagem preparados e preparações para conservação ou cuidados da pele, exceto as preparações solares e antissolares",
    "ncms": [
      "33049990"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2001600",
    "descricao": "Preparações solares e antissolares",
    "ncms": [
      "33049990"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2001700",
    "descricao": "Xampus para o cabelo",
    "ncms": [
      "33051000"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2001800",
    "descricao": "Preparações para ondulação ou alisamento, permanentes, dos cabelos",
    "ncms": [
      "33052000"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2001900",
    "descricao": "Laquês para o cabelo",
    "ncms": [
      "33053000"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2002000",
    "descricao": "Outras preparações capilares, incluindo máscaras e finalizadores",
    "ncms": [
      "33059000"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2002100",
    "descricao": "Condicionadores",
    "ncms": [
      "33059000"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2002200",
    "descricao": "Tintura para o cabelo",
    "ncms": [
      "33059000"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2002300",
    "descricao": "Dentifrícios",
    "ncms": [
      "33061000"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2002400",
    "descricao": "Fios utilizados para limpar os espaços interdentais (fios dentais)",
    "ncms": [
      "33062000"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2002500",
    "descricao": "Outras preparações para higiene bucal ou dentária",
    "ncms": [
      "33069000"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2002600",
    "descricao": "Preparações para barbear (antes, durante ou após)",
    "ncms": [
      "33071000"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2002700",
    "descricao": "Desodorantes (desodorizantes) corporais líquidos, exceto os classificados no CEST 20.027.01",
    "ncms": [
      "33072010"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2002701",
    "descricao": "Loções e óleos desodorantes hidratantes líquidos",
    "ncms": [
      "33072010"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2002800",
    "descricao": "Antiperspirantes líquidos",
    "ncms": [
      "33072010"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2002900",
    "descricao": "Outros desodorantes (desodorizantes) corporais, exceto os classificados no CEST 20.029.01",
    "ncms": [
      "33072090"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2002901",
    "descricao": "Outras loções e óleos desodorantes hidratantes",
    "ncms": [
      "33072090"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2003000",
    "descricao": "Outros antiperspirantes",
    "ncms": [
      "33072090"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2003100",
    "descricao": "Sais perfumados e outras preparações para banhos",
    "ncms": [
      "33073000"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2003200",
    "descricao": "Outros produtos de perfumaria preparados",
    "ncms": [
      "33079000"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2003201",
    "descricao": "Outros produtos de toucador preparados",
    "ncms": [
      "33079000"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2003300",
    "descricao": "Soluções para lentes de contato ou para olhos artificiais",
    "ncms": [
      "33079000"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2003400",
    "descricao": "Sabões de toucador em barras, pedaços ou figuras moldados, exceto CEST 20.034.01",
    "ncms": [
      "34011190"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2003401",
    "descricao": "Lenços umedecidos",
    "ncms": [
      "34011190"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2003500",
    "descricao": "Outros sabões, produtos e preparações, em barras, pedaços ou figuras moldados",
    "ncms": [
      "34011900"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2003600",
    "descricao": "Sabões de toucador sob outras formas",
    "ncms": [
      "34012010"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2003700",
    "descricao": "Produtos e preparações orgânicos tensoativos para lavagem da pele, na forma de líquido ou de creme, acondicionados para venda a retalho, mesmo contendo sabão",
    "ncms": [
      "34013000"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2003800",
    "descricao": "Bolsa para gelo ou para água quente",
    "ncms": [
      "40149010"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2003900",
    "descricao": "Chupetas e bicos para mamadeiras e para chupetas, de borracha",
    "ncms": [
      "40149090"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2004000",
    "descricao": "Chupetas e bicos para mamadeiras e para chupetas, de silicone",
    "ncms": [
      "39249000"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2004100",
    "descricao": "Malas e maletas de toucador",
    "ncms": [
      "42021"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2004200",
    "descricao": "Papel higiênico - folha simples",
    "ncms": [
      "48181000"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2004300",
    "descricao": "Papel higiênico - folha dupla, tripla e quádrupla",
    "ncms": [
      "48181000"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2004400",
    "descricao": "Lenços (incluídos os de maquilagem) e toalhas de mão",
    "ncms": [
      "48182000"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2004500",
    "descricao": "Papel toalha de uso institucional do tipo comercializado em rolos igual ou superior a 80 metros e do tipo comercializado em folhas intercaladas",
    "ncms": [
      "48182000"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2004600",
    "descricao": "Toalhas e guardanapos de mesa",
    "ncms": [
      "48183000"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2004700",
    "descricao": "Toalhas de cozinha (papel toalha de uso doméstico)",
    "ncms": [
      "48189090"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2004800",
    "descricao": "Fraldas, exceto os descritos no CEST 20.048.01",
    "ncms": [
      "96190000"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2004801",
    "descricao": "Fraldas de fibras têxteis",
    "ncms": [
      "96190000"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2004900",
    "descricao": "Tampões higiênicos",
    "ncms": [
      "96190000"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2005000",
    "descricao": "Absorventes higiênicos externos",
    "ncms": [
      "96190000"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2005100",
    "descricao": "Hastes flexíveis (uso não medicinal)",
    "ncms": [
      "56012190"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2005200",
    "descricao": "Sutiã descartável, assemelhados e papel para depilação",
    "ncms": [
      "56039290"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2005300",
    "descricao": "Pinças para sobrancelhas",
    "ncms": [
      "82032090"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2005400",
    "descricao": "Espátulas (artigos de cutelaria)",
    "ncms": [
      "82141000"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2005500",
    "descricao": "Utensílios e sortidos de utensílios de manicuros ou de pedicuros (incluídas as limas para unhas)",
    "ncms": [
      "82142000"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2005600",
    "descricao": "Termômetros, inclusive o digital",
    "ncms": [
      "90251110"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2005700",
    "descricao": "Escovas e pincéis de barba, escovas para cabelos, para cílios ou para unhas e outras escovas de toucador de pessoas, incluídas as que sejam partes de aparelhos, exceto escovas de dentes",
    "ncms": [
      "96032"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2005800",
    "descricao": "Escovas de dentes, incluídas as escovas para dentaduras",
    "ncms": [
      "96032100"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2005900",
    "descricao": "Pincéis para aplicação de produtos cosméticos",
    "ncms": [
      "96033000"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2006000",
    "descricao": "Sortidos de viagem, para toucador de pessoas para costura ou para limpeza de calçado ou de roupas",
    "ncms": [
      "96050000"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2006100",
    "descricao": "Pentes, travessas para cabelo e artigos semelhantes; grampos (alfinetes) para cabelo; pinças (pinceguiches), onduladores, bobes (rolos) e artefatos semelhantes para penteados, e suas partes, exceto os classificados na posição 8516 e suas partes",
    "ncms": [
      "9615"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2006200",
    "descricao": "Borlas ou esponjas para pós ou para aplicação de outros cosméticos ou de produtos de toucador",
    "ncms": [
      "96162000"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2006300",
    "descricao": "Mamadeiras",
    "ncms": [
      "7013"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2006400",
    "descricao": "Aparelhos e lâminas de barbear",
    "ncms": [
      "82121020"
    ],
    "segmento": "PRODUTOS DE PERFUMARIA E DE HIGIENE PESSOAL E COSMÉTICOS"
  },
  {
    "codigo": "2100100",
    "descricao": "Fogões de cozinha de uso doméstico e suas partes",
    "ncms": [
      "73211100"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2100200",
    "descricao": "Combinações de refrigeradores e congeladores (“freezers”), munidos de portas exteriores separadas",
    "ncms": [
      "84181000"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2100300",
    "descricao": "Refrigeradores do tipo doméstico, de compressão",
    "ncms": [
      "84182100"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2100400",
    "descricao": "Outros refrigeradores do tipo doméstico",
    "ncms": [
      "84182900"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2100500",
    "descricao": "Congeladores (“freezers”) horizontais tipo arca, de capacidade não superior a 800 litros",
    "ncms": [
      "84183000"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2100600",
    "descricao": "Congeladores (“freezers”) verticais tipo armário, de capacidade não superior a 900 litros",
    "ncms": [
      "84184000"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2100700",
    "descricao": "Outros móveis (arcas, armários, vitrines, balcões e móveis semelhantes) para a conservação e exposição de produtos, que incorporem um equipamento para a produção de frio",
    "ncms": [
      "841850"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2100800",
    "descricao": "Mini adega e similares",
    "ncms": [
      "8418699"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2100900",
    "descricao": "Máquinas para produção de gelo",
    "ncms": [
      "84186999"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2101000",
    "descricao": "Partes dos refrigeradores, congeladores, mini adegas e similares, máquinas para produção de gelo e bebedouros descritos nos CEST 21.002.00, 21.003.00, 21.004.00, 21.005.00, 21.006.00, 21.007.00, 21.008.00, 21.009.00 e 21.013.00",
    "ncms": [
      "84189900"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2101100",
    "descricao": "Secadoras de roupa de uso doméstico",
    "ncms": [
      "842112"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2101200",
    "descricao": "Outras secadoras de roupas e centrífugas de uso doméstico",
    "ncms": [
      "84211990"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2101300",
    "descricao": "Bebedouros refrigerados para água",
    "ncms": [
      "84186931"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2101400",
    "descricao": "Partes das secadoras de roupas e centrífugas de uso doméstico e dos aparelhos para filtrar ou depurar água, descritos nos CEST 21.011.00 e 21.012.00 e 21.098.00",
    "ncms": [
      "84219"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2101500",
    "descricao": "Máquinas de lavar louça do tipo doméstico e suas partes",
    "ncms": [
      "84221100"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2101600",
    "descricao": "Máquinas que executem pelo menos duas das seguintes funções: impressão, cópia ou transmissão de telecópia (fax), capazes de ser conectadas a uma máquina automática para processamento de dados ou a uma rede",
    "ncms": [
      "844331"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2101700",
    "descricao": "Outras impressoras, máquinas copiadoras e telecopiadores (fax), mesmo combinados entre si, capazes de ser conectados a uma máquina automática para processamento de dados ou a uma rede",
    "ncms": [
      "844332"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2101800",
    "descricao": "Partes e acessórios de máquinas e aparelhos de impressão por meio de blocos, cilindros e outros elementos de impressão da posição 8442; e de outras impressoras, máquinas copiadoras e telecopiadores (fax), mesmo combinados entre si",
    "ncms": [
      "84439"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2101900",
    "descricao": "Máquinas de lavar roupa, mesmo com dispositivos de secagem, de uso doméstico, de capacidade não superior a 10 kg, em peso de roupa seca, inteiramente automáticas",
    "ncms": [
      "84501100"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2102000",
    "descricao": "Outras máquinas de lavar roupa, mesmo com dispositivos de secagem, de uso doméstico, com secador centrífugo incorporado",
    "ncms": [
      "84501200"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2102100",
    "descricao": "Outras máquinas de lavar roupa, mesmo com dispositivos de secagem, de uso doméstico",
    "ncms": [
      "84501900"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2102200",
    "descricao": "Máquinas de lavar roupa, mesmo com dispositivos de secagem, de uso doméstico, de capacidade superior a 10 kg, em peso de roupa seca",
    "ncms": [
      "845020"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2102300",
    "descricao": "Partes de máquinas de lavar roupa, mesmo com dispositivos de secagem, de uso doméstico",
    "ncms": [
      "845090"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2102400",
    "descricao": "Máquinas de secar de uso doméstico de capacidade não superior a 10 kg, em peso de roupa seca",
    "ncms": [
      "84512100"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2102500",
    "descricao": "Outras máquinas de secar de uso doméstico",
    "ncms": [
      "84512990"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2102600",
    "descricao": "Partes de máquinas de secar de uso doméstico",
    "ncms": [
      "845190"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2102700",
    "descricao": "Máquinas de costura de uso doméstico",
    "ncms": [
      "84521000"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2102800",
    "descricao": "Máquinas automáticas para processamento de dados, portáteis, de peso não superior a 10 kg, contendo pelo menos uma unidade central de processamento, um teclado e uma tela",
    "ncms": [
      "847130"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2102900",
    "descricao": "Outras máquinas automáticas para processamento de dados",
    "ncms": [
      "84714"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2103000",
    "descricao": "Unidades de processamento, de pequena capacidade, exceto as das subposições 8471.41 ou 8471.49, podendo conter, no mesmo corpo, um ou dois dos seguintes tipos de unidades: unidade de memória, unidade de entrada e unidade de saída; baseadas em microprocessadores, com capacidade de instalação, dentro do mesmo gabinete, de unidades de memória da subposição 8471.70, podendo conter múltiplos conectores de expansão (“slots”), e valor FOB inferior ou igual a US$ 12.500,00, por unidade",
    "ncms": [
      "84715010"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2103100",
    "descricao": "Unidades de entrada, exceto as classificadas no código 8471.60.54",
    "ncms": [
      "8471605"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2103200",
    "descricao": "Outras unidades de entrada ou de saída, podendo conter, no mesmo corpo, unidades de memória",
    "ncms": [
      "84716090"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2103300",
    "descricao": "Unidades de memória",
    "ncms": [
      "847170"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2103400",
    "descricao": "Outras máquinas automáticas para processamento de dados e suas unidades; leitores magnéticos ou ópticos, máquinas para registrar dados em suporte sob forma codificada, e máquinas para processamento desses dados, não especificadas nem compreendidas em outras posições",
    "ncms": [
      "847190"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2103500",
    "descricao": "Partes e acessórios das máquinas da posição 84.71",
    "ncms": [
      "847330"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2103600",
    "descricao": "Outros transformadores, exceto os classificados nos códigos 8504.33.00 e 8504.34.00",
    "ncms": [
      "85043"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2103700",
    "descricao": "Carregadores de acumuladores",
    "ncms": [
      "85044010"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2103800",
    "descricao": "Equipamentos de alimentação ininterrupta de energia (UPS ou “no break”)",
    "ncms": [
      "85044040"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2103900",
    "descricao": "Outros acumuladores",
    "ncms": [
      "85078000"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2104000",
    "descricao": "Aspiradores",
    "ncms": [
      "8508"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2104100",
    "descricao": "Aparelhos eletromecânicos de motor elétrico incorporado, de uso doméstico e suas partes",
    "ncms": [
      "8509"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2104200",
    "descricao": "Enceradeiras",
    "ncms": [
      "85098010"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2104300",
    "descricao": "Chaleiras elétricas",
    "ncms": [
      "85161000"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2104400",
    "descricao": "Ferros elétricos de passar",
    "ncms": [
      "85164000"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2104500",
    "descricao": "Fornos de micro-ondas",
    "ncms": [
      "85165000"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2104600",
    "descricao": "Outros fornos; fogareiros (incluídas as chapas de cocção), grelhas e assadeiras, exceto os portáteis",
    "ncms": [
      "85166000"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2104700",
    "descricao": "Outros fornos; fogareiros (incluídas as chapas de cocção), grelhas e assadeiras, portáteis",
    "ncms": [
      "85166000"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2104800",
    "descricao": "Outros aparelhos eletrotérmicos de uso doméstico - Cafeteiras",
    "ncms": [
      "85167100"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2104900",
    "descricao": "Outros aparelhos eletrotérmicos de uso doméstico - Torradeiras",
    "ncms": [
      "85167200"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2105000",
    "descricao": "Outros aparelhos eletrotérmicos de uso doméstico",
    "ncms": [
      "851679"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2105100",
    "descricao": "Partes das chaleiras, ferros, fornos e outros aparelhos eletrotérmicos da posição 85.16, descritos nos CEST 21.043.00, 21.044.00, 21.045.00, 21.046.00, 21.047.00, 21.048.00, 21.049.00 e 21.050.00",
    "ncms": [
      "85169000"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2105200",
    "descricao": "Aparelhos telefônicos por fio com unidade auscultador - microfone sem fio",
    "ncms": [
      "85171100"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2105300",
    "descricao": "Telefones inteligentes (“smartphones”) e para redes celulares, excetos por satélite, os de uso automotivo e os classificados nos CEST 21.053.01",
    "ncms": [
      "85171300"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2105301",
    "descricao": "Telefones inteligentes (“smartphones”) e para redes celulares portáteis, excetos por satélite",
    "ncms": [
      "85171300"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2105400",
    "descricao": "Outros telefones para outras redes sem fio, excetos os de uso automotivo e os classificados nos CEST 21.053.00 e 21.053.01",
    "ncms": [
      "851714"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2105500",
    "descricao": "Outros aparelhos telefônicos não combinados com outros aparelhos",
    "ncms": [
      "85171830"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2105501",
    "descricao": "Outros aparelhos telefônicos",
    "ncms": [
      "85171890"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2105601",
    "descricao": "Distribuidores de conexões para rede (“hubs”) e moduladores/demoduladores (“modens”).",
    "ncms": [
      "85176254"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2105700",
    "descricao": "Microfones e seus suportes; alto-falantes, mesmo montados nos seus receptáculos, fones de ouvido (auscultadores), mesmo combinados com microfone e conjuntos ou sortidos constituídos por um microfone e um ou mais alto-falantes, amplificadores elétricos de audiofrequência, aparelhos elétricos de amplificação de som; suas partes e acessórios; exceto os de uso automotivo",
    "ncms": [
      "8518"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2105800",
    "descricao": "Aparelhos de radiodifusão suscetíveis de funcionarem sem fonte externa de energia. Aparelhos de gravação de som; aparelhos de reprodução de som; aparelhos de gravação e de reprodução de som; partes e acessórios; exceto os de uso automotivo",
    "ncms": [
      "8519"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2105900",
    "descricao": "Outros aparelhos de gravação de som; aparelhos de reprodução de som; aparelhos de gravação e de reprodução de som; partes e acessórios; exceto os de uso automotivo",
    "ncms": [
      "85198190"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2106000",
    "descricao": "Gravador-reprodutor e editor de imagem e som, em discos, por meio magnético, óptico ou optomagnético, exceto de uso automotivo",
    "ncms": [
      "85219010"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2106100",
    "descricao": "Outros aparelhos videofônicos de gravação ou reprodução, mesmo incorporando um receptor de sinais videofônicos, exceto os de uso automotivo",
    "ncms": [
      "85219090"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2106200",
    "descricao": "Cartões de memória (\"memorycards\")",
    "ncms": [
      "85235110"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2106300",
    "descricao": "Cartões inteligentes (\"smartcards\"), exceto o item classificado no CEST 21.064.00",
    "ncms": [
      "852352"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2106400",
    "descricao": "Cartões inteligentes (\"sim cards\")",
    "ncms": [
      "852352"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2106500",
    "descricao": "Câmeras fotográficas digitais e câmeras de vídeo",
    "ncms": [
      "8525892"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2106600",
    "descricao": "Outros aparelhos receptores para radiodifusão, mesmo combinados num invólucro, com um aparelho de gravação ou de reprodução de som, ou com um relógio, inclusive caixa acústica para Home Theaters classificados na posição 8518",
    "ncms": [
      "85279"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2106701",
    "descricao": "Projetores capazes de serem conectados diretamente a uma máquina automática para processamento de dados da posição 84.71 e concebidos para serem utilizados com esta máquina",
    "ncms": [
      "85286200"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2106800",
    "descricao": "Outros monitores capazes de serem conectados diretamente a uma máquina automática para processamento de dados da posição 84.71 e concebidos para serem utilizados com esta máquina, policromáticos",
    "ncms": [
      "85285200"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2106900",
    "descricao": "Aparelhos receptores de televisão, mesmo que incorporem um aparelho receptor de radiodifusão ou um aparelho de gravação ou reprodução de som ou de imagens - Televisores de CRT (tubo de raios catódicos)",
    "ncms": [
      "85287"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2107000",
    "descricao": "Aparelhos receptores de televisão, mesmo que incorporem um aparelho receptor de radiodifusão ou um aparelho de gravação ou reprodução de som ou de imagens - Televisores de LCD (Display de Cristal Líquido)",
    "ncms": [
      "85287"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2107100",
    "descricao": "Aparelhos receptores de televisão, mesmo que incorporem um aparelho receptor de radiodifusão ou um aparelho de gravação ou reprodução de som ou de imagens - Televisores de Plasma",
    "ncms": [
      "85287"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2107200",
    "descricao": "Outros aparelhos receptores de televisão não dotados de monitores ou display de vídeo",
    "ncms": [
      "85287"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2107300",
    "descricao": "Outros aparelhos receptores de televisão não relacionados nos CEST 21.069.00, 21.070.00, 21.071.00 e 21.072.00",
    "ncms": [
      "85287"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2107400",
    "descricao": "Câmeras fotográficas dos tipos utilizadas para preparação de clichês ou cilindros de impressão",
    "ncms": [
      "900659"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2107500",
    "descricao": "Câmeras fotográficas para filmes de revelação e copiagem instantâneas",
    "ncms": [
      "90064000"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2107600",
    "descricao": "Aparelhos de diatermia",
    "ncms": [
      "90189050"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2107700",
    "descricao": "Aparelhos de massagem",
    "ncms": [
      "90191000"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2107800",
    "descricao": "Reguladores de voltagem eletrônicos",
    "ncms": [
      "90328911"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2107900",
    "descricao": "Consoles e máquinas de jogos de vídeo, exceto os classificados na subposição 9504.30",
    "ncms": [
      "95045000"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2108000",
    "descricao": "Multiplexadores e concentradores",
    "ncms": [
      "8517621"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2108100",
    "descricao": "Centrais automáticas privadas, de capacidade inferior ou igual a 25 ramais",
    "ncms": [
      "85176229"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2108200",
    "descricao": "Outros aparelhos para comutação",
    "ncms": [
      "85176239"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2108300",
    "descricao": "Roteadores digitais, em redes com ou sem fio",
    "ncms": [
      "8517624"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2108400",
    "descricao": "Aparelhos emissores com receptor incorporado de tecnologia celular",
    "ncms": [
      "85176262"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2108500",
    "descricao": "Outros aparelhos de recepção, conversão e transmissão ou regeneração de voz, imagens ou outros dados, incluindo os aparelhos de comutação e roteamento",
    "ncms": [
      "8517629"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2108600",
    "descricao": "Antenas próprias para telefones celulares portáteis, exceto as telescópicas",
    "ncms": [
      "85177110"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2108700",
    "descricao": "Aparelhos ou máquinas de barbear, máquinas de cortar o cabelo ou de tosquiar e aparelhos de depilar, e suas partes",
    "ncms": [
      "821490"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2108800",
    "descricao": "Ventiladores, exceto os de uso agrícola e do CEST 21.088.01",
    "ncms": [
      "84145"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2108801",
    "descricao": "Microventiladores com área de carcaça inferior a 90 cm²",
    "ncms": [
      "84145910"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2108900",
    "descricao": "Ventiladores de uso agrícola",
    "ncms": [
      "84145990"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2109000",
    "descricao": "Coifas com dimensão horizontal máxima não superior a 120 cm",
    "ncms": [
      "84146000"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2109100",
    "descricao": "Partes de ventiladores ou coifas aspirantes",
    "ncms": [
      "84149020"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2109200",
    "descricao": "Máquinas e aparelhos de ar condicionado contendo um ventilador motorizado e dispositivos próprios para modificar a temperatura e a umidade, incluídos as máquinas e aparelhos em que a umidade não seja regulável separadamente",
    "ncms": [
      "841510"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2109300",
    "descricao": "Aparelhos de ar-condicionado tipo Split System (sistema com elementos separados) com unidade externa e interna",
    "ncms": [
      "84151011"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2109400",
    "descricao": "Aparelhos de ar-condicionado com capacidade inferior ou igual a 30.000 frigorias/hora",
    "ncms": [
      "84151019"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2109500",
    "descricao": "Aparelhos de ar-condicionado com capacidade acima de 30.000 frigorias/hora",
    "ncms": [
      "84151090"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2109600",
    "descricao": "Unidades evaporadoras (internas) de aparelho de ar-condicionado do tipo Split System (sistema com elementos separados), com capacidade inferior ou igual a 30.000 frigorias/hora",
    "ncms": [
      "84159010"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2109700",
    "descricao": "Unidades condensadoras (externas) de aparelho de ar-condicionado do tipo Split System (sistema com elementos separados), com capacidade inferior ou igual a 30.000 frigorias/hora",
    "ncms": [
      "84159020"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2109800",
    "descricao": "Aparelhos elétricos para filtrar ou depurar água (purificadores de água refrigerados), exceto os itens classificados no CEST 21.098.01",
    "ncms": [
      "84212100"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2109801",
    "descricao": "Outros aparelhos elétricos para filtrar ou depurar água",
    "ncms": [
      "84212100"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2109900",
    "descricao": "Lavadora de alta pressão e suas partes",
    "ncms": [
      "84243010"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2110000",
    "descricao": "Furadeiras elétricas",
    "ncms": [
      "84672100"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2110100",
    "descricao": "Aparelhos elétricos para aquecimento de ambientes",
    "ncms": [
      "85162"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2110200",
    "descricao": "Secadores de cabelo",
    "ncms": [
      "85163100"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2110300",
    "descricao": "Outros aparelhos para arranjos do cabelo",
    "ncms": [
      "85163200"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2110400",
    "descricao": "Aparelhos receptores para radiodifusão, mesmo combinados num mesmo invólucro, com um aparelho de gravação ou de reprodução de som, ou com um relógio, exceto os classificados na posição 8527.1, 8527.2 e 8527.9 que sejam de uso automotivo",
    "ncms": [
      "8527"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2110500",
    "descricao": "Climatizadores de ar",
    "ncms": [
      "84796000"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2110600",
    "descricao": "Outras partes para máquinas e aparelhos de ar-condicionado que contenham um ventilador motorizado e dispositivos próprios para modificar a temperatura e a umidade, incluindo as máquinas e aparelhos em que a umidade não seja regulável separadamente",
    "ncms": [
      "84159090"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2110700",
    "descricao": "Câmeras de televisão",
    "ncms": [
      "8525891"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2110800",
    "descricao": "Balanças de uso doméstico",
    "ncms": [
      "84231000"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2110900",
    "descricao": "Tubos e válvulas, eletrônicos, de cátodo quente, cátodo frio ou fotocátodo (por exemplo, tubos e válvulas, de vácuo, de vapor ou de gás, ampolas retificadoras de vapor de mercúrio, tubos catódicos, tubos e válvulas para câmeras de televisão)",
    "ncms": [
      "8540"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2111000",
    "descricao": "Aparelhos elétricos para telefonia; outros aparelhos para transmissão ou recepção de voz, imagens ou outros dados, incluídos os aparelhos para comunicação em redes por fio ou redes sem fio, tal como uma rede local (LAN) ou uma rede de área estendida (WAN), incluídas suas partes, exceto os de uso automotivo, os classificados nos códigos NCM/SH 8517.62.51, 8517.62.52 e 8517.62.53 e no código CEST 21.127.00",
    "ncms": [
      "8517"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2111100",
    "descricao": "Interfones, seus acessórios, tomadas e “plugs”",
    "ncms": [
      "8517"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2111200",
    "descricao": "Partes reconhecíveis como exclusiva ou principalmente destinadas aos aparelhos das posições 8525 a 8528; exceto as de uso automotivo",
    "ncms": [
      "8529"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2111300",
    "descricao": "Aparelhos elétricos de sinalização acústica ou visual (por exemplo, campainhas, sirenes, quadros indicadores, aparelhos de alarme para proteção contra roubo ou incêndio); exceto os de uso automotivo e os classificados nas posições 8531.10 e 8531.80.00.",
    "ncms": [
      "8531"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2111400",
    "descricao": "Aparelhos elétricos de alarme, para proteção contra roubo ou incêndio e aparelhos semelhantes, exceto os de uso automotivo",
    "ncms": [
      "853110"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2111500",
    "descricao": "Outros aparelhos de sinalização acústica ou visual, exceto os de uso automotivo",
    "ncms": [
      "85318000"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2111600",
    "descricao": "Circuitos impressos, exceto os de uso automotivo",
    "ncms": [
      "853400"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2111700",
    "descricao": "Diodos emissores de luz (LED), exceto diodos “laser”",
    "ncms": [
      "85414111"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2111800",
    "descricao": "Eletrificadores de cercas eletrônicos",
    "ncms": [
      "85437092"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2111900",
    "descricao": "Aparelhos e instrumentos para medida ou controle da tensão, intensidade, resistência ou da potência, sem dispositivo registrador; exceto os de uso automotivo",
    "ncms": [
      "90303"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2112000",
    "descricao": "Analisadores lógicos de circuitos digitais, de espectro de frequência, frequencímetros, fasímetros, e outros instrumentos e aparelhos de controle de grandezas elétricas e detecção",
    "ncms": [
      "903089"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2112100",
    "descricao": "Interruptores horários e outros aparelhos que permitam acionar um mecanismo em tempo determinado, munidos de maquinismo de aparelhos de relojoaria ou de motor síncrono",
    "ncms": [
      "910700"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2112200",
    "descricao": "Aparelhos de iluminação (incluídos os projetores) e suas partes, não especificados nem compreendidos em outras posições; anúncios, cartazes ou tabuletas e placas indicadoras luminosos, e artigos semelhantes, contendo uma fonte luminosa fixa permanente, e suas partes não especificadas nem compreendidas em outras posições, com exceção dos itens classificados nos CEST 21.123.00, 21.124.00 e 21.125.00",
    "ncms": [
      "9405"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2112300",
    "descricao": "Lustres e outros aparelhos elétricos de iluminação, próprios para serem suspensos ou fixados no teto ou na parede, exceto os dos tipos utilizados na iluminação pública; e suas partes",
    "ncms": [
      "94051"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2112400",
    "descricao": "Abajures de cabeceiras, de escritório e lampadários de interior, elétricos e suas partes",
    "ncms": [
      "94052"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2112500",
    "descricao": "Outras luminárias e aparelhos de iluminação, elétricos, e suas partes",
    "ncms": [
      "94054"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2112600",
    "descricao": "Microprocessador",
    "ncms": [
      "85423190"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2112700",
    "descricao": "Aparelho emissor com receptor incorporado, digital, com tecnologias de transmissão/recepção sem fio, tela sensível ao toque “smartwatch”",
    "ncms": [
      "85176277"
    ],
    "segmento": "PRODUTOS ELETRÔNICOS, ELETROELETRÔNICOS E ELETRODOMÉSTICOS"
  },
  {
    "codigo": "2200100",
    "descricao": "Ração tipo “pet” para animais domésticos",
    "ncms": [
      "2309"
    ],
    "segmento": "RAÇÕES PARA ANIMAIS DOMÉSTICOS"
  },
  {
    "codigo": "2300100",
    "descricao": "Sorvetes de qualquer espécie",
    "ncms": [
      "210500"
    ],
    "segmento": "SORVETES E PREPARADOS PARA FABRICAÇÃO DE SORVETES EM MÁQUINAS"
  },
  {
    "codigo": "2300200",
    "descricao": "Preparados para fabricação de sorvete em máquina",
    "ncms": [
      "1806"
    ],
    "segmento": "SORVETES E PREPARADOS PARA FABRICAÇÃO DE SORVETES EM MÁQUINAS"
  },
  {
    "codigo": "2400100",
    "descricao": "Tintas, vernizes",
    "ncms": [
      "3208"
    ],
    "segmento": "TINTAS E VERNIZES"
  },
  {
    "codigo": "2400200",
    "descricao": "Xadrez e pós assemelhados, em embalagem de conteúdo inferior ou igual a 1 kg, exceto pigmentos à base de dióxido de titânio classificados no código NCM 3206.11.10",
    "ncms": [
      "2821"
    ],
    "segmento": "TINTAS E VERNIZES"
  },
  {
    "codigo": "2400201",
    "descricao": "Xadrez e pós assemelhados, em embalagem de conteúdo superior a 1 kg, exceto pigmentos à base de dióxido de titânio classificados no código NCM 3206.11.10",
    "ncms": [
      "2821"
    ],
    "segmento": "TINTAS E VERNIZES"
  },
  {
    "codigo": "2400300",
    "descricao": "Corantes para aplicação em bases, tintas e vernizes",
    "ncms": [
      "3204"
    ],
    "segmento": "TINTAS E VERNIZES"
  },
  {
    "codigo": "2500100",
    "descricao": "Veículos automóveis para transporte de 10 pessoas ou mais, incluindo o motorista, unicamente com motor de pistão, de ignição por compressão (diesel ou semidiesel), com volume interno de habitáculo, destinado a passageiros e motorista, superior a 6 m³, mas inferior a 9 m³",
    "ncms": [
      "87021000"
    ],
    "segmento": "VEÍCULOS AUTOMOTORES"
  },
  {
    "codigo": "2500200",
    "descricao": "Veículos automóveis para transporte de 10 pessoas ou mais, incluindo o motorista, unicamente com motor elétrico para propulsão, com volume interno de habitáculo, destinado a passageiros e motorista, superior a 6 m³, mas inferior a 9 m³",
    "ncms": [
      "87024090"
    ],
    "segmento": "VEÍCULOS AUTOMOTORES"
  },
  {
    "codigo": "2500300",
    "descricao": "Automóveis unicamente com motor de pistão alternativo de ignição por centelha (faísca*), de cilindrada não superior a 1000 cm³",
    "ncms": [
      "87032100"
    ],
    "segmento": "VEÍCULOS AUTOMOTORES"
  },
  {
    "codigo": "2500400",
    "descricao": "Automóveis unicamente com motor de pistão alternativo de ignição por centelha (faísca*), de cilindrada superior a 1000 cm³, mas não superior a 1500 cm³, com capacidade de transporte de pessoas sentadas inferior ou igual a 6, incluído o condutor, exceto carro celular",
    "ncms": [
      "87032210"
    ],
    "segmento": "VEÍCULOS AUTOMOTORES"
  },
  {
    "codigo": "2500500",
    "descricao": "Outros automóveis unicamente com motor de pistão alternativo de ignição por centelha (faísca*), de cilindrada superior a 1000 cm³, mas não superior a 1500 cm³, exceto carro celular",
    "ncms": [
      "87032290"
    ],
    "segmento": "VEÍCULOS AUTOMOTORES"
  },
  {
    "codigo": "2500600",
    "descricao": "Automóveis unicamente com motor de pistão alternativo de ignição por centelha (faísca*), de cilindrada superior a 1500 cm³, mas não superior a 3000 cm³, com capacidade de transporte de pessoas sentadas inferior ou igual a 6, incluído o condutor, exceto carro celular, carro funerário e automóveis de corrida",
    "ncms": [
      "87032310"
    ],
    "segmento": "VEÍCULOS AUTOMOTORES"
  },
  {
    "codigo": "2500700",
    "descricao": "Outros automóveis unicamente com motor de pistão alternativo de ignição por centelha (faísca*), de cilindrada superior a 1500 cm³, mas não superior a 3000 cm³, exceto carro celular, carro funerário e automóveis de corrida",
    "ncms": [
      "87032390"
    ],
    "segmento": "VEÍCULOS AUTOMOTORES"
  },
  {
    "codigo": "2500800",
    "descricao": "Automóveis unicamente com motor de pistão alternativo de ignição por centelha (faísca*), de cilindrada superior a 3000 cm³, com capacidade de transporte de pessoas sentadas inferior ou igual a 6, incluído o condutor, exceto carro celular, carro funerário e automóveis de corrida",
    "ncms": [
      "87032410"
    ],
    "segmento": "VEÍCULOS AUTOMOTORES"
  },
  {
    "codigo": "2500900",
    "descricao": "Outros automóveis unicamente com motor de pistão alternativo de ignição por centelha (faísca*), de cilindrada superior a 3000 cm³, exceto carro celular, carro funerário e automóveis de corrida",
    "ncms": [
      "87032490"
    ],
    "segmento": "VEÍCULOS AUTOMOTORES"
  },
  {
    "codigo": "2501000",
    "descricao": "Automóveis unicamente com motor diesel ou semidiesel, de cilindrada superior a 1500 cm³, mas não superior a 2500 cm³, com capacidade de transporte de pessoas sentadas inferior ou igual a 6, incluído o condutor, exceto ambulância, carro celular e carro funerário",
    "ncms": [
      "87033210"
    ],
    "segmento": "VEÍCULOS AUTOMOTORES"
  },
  {
    "codigo": "2501100",
    "descricao": "Outros automóveis unicamente com motor diesel ou semidiesel, de cilindrada superior a 1500 cm³, mas não superior a 2500 cm³, exceto ambulância, carro celular e carro funerário",
    "ncms": [
      "87033290"
    ],
    "segmento": "VEÍCULOS AUTOMOTORES"
  },
  {
    "codigo": "2501200",
    "descricao": "Automóveis unicamente com motor diesel ou semidiesel, de cilindrada superior a 2500 cm³, com capacidade de transporte de pessoas sentadas inferior ou igual a 6, incluído o condutor, exceto carro celular e carro funerário",
    "ncms": [
      "87033310"
    ],
    "segmento": "VEÍCULOS AUTOMOTORES"
  },
  {
    "codigo": "2501300",
    "descricao": "Outros automóveis unicamente com motor diesel ou semidiesel, de cilindrada superior a 2500 cm³, exceto carro celular e carro funerário",
    "ncms": [
      "87033390"
    ],
    "segmento": "VEÍCULOS AUTOMOTORES"
  },
  {
    "codigo": "2501400",
    "descricao": "Veículos automóveis para transporte de mercadorias, de peso em carga máxima não superior a 5 toneladas, chassis com motor diesel ou semidiesel e cabina, exceto caminhão de peso em carga máxima superior a 3,9 toneladas",
    "ncms": [
      "87042110"
    ],
    "segmento": "VEÍCULOS AUTOMOTORES"
  },
  {
    "codigo": "2501500",
    "descricao": "Veículos automóveis para transporte de mercadorias, de peso em carga máxima não superior a 5 toneladas, com motor diesel ou semidiesel, com caixa basculante, exceto caminhão de peso em carga máxima superior a 3,9 toneladas",
    "ncms": [
      "87042120"
    ],
    "segmento": "VEÍCULOS AUTOMOTORES"
  },
  {
    "codigo": "2501600",
    "descricao": "Veículos automóveis para transporte de mercadorias, de peso em carga máxima não superior a 5 toneladas, frigoríficos ou isotérmicos, com motor diesel ou semidiesel, exceto caminhão de peso em carga máxima superior a 3,9 toneladas",
    "ncms": [
      "87042130"
    ],
    "segmento": "VEÍCULOS AUTOMOTORES"
  },
  {
    "codigo": "2501700",
    "descricao": "Outros veículos automóveis para transporte de mercadorias, de peso em carga máxima não superior a 5 toneladas, com motor diesel ou semidiesel, exceto carro-forte para transporte de valores e caminhão de peso em carga máxima superior a 3,9 toneladas",
    "ncms": [
      "87042190"
    ],
    "segmento": "VEÍCULOS AUTOMOTORES"
  },
  {
    "codigo": "2501800",
    "descricao": "Veículos automóveis para transporte de mercadorias, de peso em carga máxima não superior a 5 toneladas, com motor a explosão, chassis e cabina, exceto caminhão de peso em carga máxima superior a 3,9 toneladas",
    "ncms": [
      "87043110"
    ],
    "segmento": "VEÍCULOS AUTOMOTORES"
  },
  {
    "codigo": "2501900",
    "descricao": "Veículos automóveis para transporte de mercadorias, de peso em carga máxima não superior a 5 toneladas, com motor explosão com caixa basculante, exceto caminhão de peso em carga máxima superior a 3,9 toneladas",
    "ncms": [
      "87043120"
    ],
    "segmento": "VEÍCULOS AUTOMOTORES"
  },
  {
    "codigo": "2502000",
    "descricao": "Veículos automóveis para transporte de mercadorias, de peso em carga máxima não superior a 5 toneladas, frigoríficos ou isotérmicos com motor explosão, exceto caminhão de peso em carga máxima superior a 3,9 toneladas",
    "ncms": [
      "87043130"
    ],
    "segmento": "VEÍCULOS AUTOMOTORES"
  },
  {
    "codigo": "2502100",
    "descricao": "Outros veículos automóveis para transporte de mercadorias, de peso em carga máxima não superior a 5 toneladas, com motor a explosão, exceto carro-forte para transporte de valores e caminhão de peso em carga máxima superior a 3,9 toneladas",
    "ncms": [
      "87043190"
    ],
    "segmento": "VEÍCULOS AUTOMOTORES"
  },
  {
    "codigo": "2502200",
    "descricao": "Veículos automóveis para transporte de 10 pessoas ou mais, incluindo o motorista, com motor de pistão, de ignição por compressão (diesel ou semidiesel) e um motor elétrico, com volume interno de habitáculo, destinado a passageiros e motorista, superior a 6 m³, mas inferior a 9 m³",
    "ncms": [
      "87022000"
    ],
    "segmento": "VEÍCULOS AUTOMOTORES"
  },
  {
    "codigo": "2502300",
    "descricao": "Veículos automóveis para transporte de 10 pessoas ou mais, incluindo o motorista, com motor de pistão alternativo, de ignição por centelha (faísca) e um motor elétrico, com volume interno de habitáculo, destinado a passageiros e motorista, superior a 6 m³, mas inferior a 9 m³",
    "ncms": [
      "87023000"
    ],
    "segmento": "VEÍCULOS AUTOMOTORES"
  },
  {
    "codigo": "2502400",
    "descricao": "Outros veículos automóveis para transporte de 10 pessoas ou mais, incluindo o motorista, com volume interno de habitáculo, destinado a passageiros e motorista, superior a 6 m³, mas inferior a 9 m³",
    "ncms": [
      "87029000"
    ],
    "segmento": "VEÍCULOS AUTOMOTORES"
  },
  {
    "codigo": "2502500",
    "descricao": "Automóveis equipados para propulsão, simultaneamente, com um motor de pistão alternativo de ignição por centelha (faísca*) e um motor elétrico, exceto os suscetíveis de serem carregados por conexão a uma fonte externa de energia elétrica, o carro celular e o carro funerário",
    "ncms": [
      "87034000"
    ],
    "segmento": "VEÍCULOS AUTOMOTORES"
  },
  {
    "codigo": "2502600",
    "descricao": "Automóveis equipados para propulsão, simultaneamente, com um motor de pistão por compressão (diesel ou semidiesel) e um motor elétrico, exceto os suscetíveis de serem carregados por conexão a uma fonte externa de energia elétrica, exceto o carro celular e o carro funerário",
    "ncms": [
      "87035000"
    ],
    "segmento": "VEÍCULOS AUTOMOTORES"
  },
  {
    "codigo": "2502700",
    "descricao": "Automóveis equipados para propulsão, simultaneamente, com um motor de pistão alternativo de ignição por centelha (faísca*) e um motor elétrico, suscetíveis de serem carregados por conexão a uma fonte externa de energia elétrica, exceto o carro celular e o carro funerário",
    "ncms": [
      "87036000"
    ],
    "segmento": "VEÍCULOS AUTOMOTORES"
  },
  {
    "codigo": "2502800",
    "descricao": "Automóveis equipados para propulsão, simultaneamente, com um motor de pistão por compressão (diesel ou semidiesel) e um motor elétrico, suscetíveis de serem carregados por conexão a uma fonte externa de energia elétrica, exceto o carro celular e o carro funerário",
    "ncms": [
      "87037000"
    ],
    "segmento": "VEÍCULOS AUTOMOTORES"
  },
  {
    "codigo": "2502900",
    "descricao": "Outros veículos, equipados unicamente com motor elétrico para propulsão",
    "ncms": [
      "87038000"
    ],
    "segmento": "VEÍCULOS AUTOMOTORES"
  },
  {
    "codigo": "2503000",
    "descricao": "Outros veículos para transportes de mercadorias equipados para propulsão, simultaneamente, com motor de pistão de ignição por compressão (diesel ou semidiesel) e motor elétrico de peso em carga máxima (bruto) não superior a 5 toneladas, exceto caminhão de peso em carga máxima superior a 3,9 toneladas",
    "ncms": [
      "87044100"
    ],
    "segmento": "VEÍCULOS AUTOMOTORES"
  },
  {
    "codigo": "2503100",
    "descricao": "Outros veículos para transportes de mercadorias equipados para propulsão, simultaneamente, com motor de pistão de ignição por centelha (faísca) e motor elétrico de peso em carga máxima (bruto) não superior a 5 toneladas, exceto caminhão de peso em carga máxima superior a 3,9 toneladas",
    "ncms": [
      "87045100"
    ],
    "segmento": "VEÍCULOS AUTOMOTORES"
  },
  {
    "codigo": "2600100",
    "descricao": "Motocicletas (incluídos os ciclomotores) e outros ciclos equipados com motor auxiliar, mesmo com carro lateral, exceto os classificados no CEST 26.001.01; carros laterais.",
    "ncms": [
      "8711"
    ],
    "segmento": "VEÍCULOS DE DUAS E TRÊS RODAS MOTORIZADOS"
  },
  {
    "codigo": "2600101",
    "descricao": "Bicicletas e outros ciclos (incluídos os triciclos) com propulsão de motor elétrico auxiliar assistido pela força humana.",
    "ncms": [
      "8711"
    ],
    "segmento": "VEÍCULOS DE DUAS E TRÊS RODAS MOTORIZADOS"
  },
  {
    "codigo": "2800100",
    "descricao": "Perfumes (extratos)",
    "ncms": [
      "33030010"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2800200",
    "descricao": "Águas-de-colônia",
    "ncms": [
      "33030020"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2800300",
    "descricao": "Produtos de maquiagem para os lábios",
    "ncms": [
      "33041000"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2800400",
    "descricao": "Sombra, delineador, lápis para sobrancelhas e rímel",
    "ncms": [
      "33042010"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2800500",
    "descricao": "Outros produtos de maquiagem para os olhos",
    "ncms": [
      "33042090"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2800600",
    "descricao": "Preparações para manicuros e pedicuros",
    "ncms": [
      "33043000"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2800700",
    "descricao": "Pós para maquiagem, incluindo os compactos",
    "ncms": [
      "33049100"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2800800",
    "descricao": "Cremes de beleza, cremes nutritivos e loções tônicas",
    "ncms": [
      "33049910"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2800900",
    "descricao": "Outros produtos de beleza ou de maquiagem preparados e preparações para conservação ou cuidados da pele, exceto as preparações antissolares e os bronzeadores",
    "ncms": [
      "33049990"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2801000",
    "descricao": "Preparações antissolares e os bronzeadores",
    "ncms": [
      "33049990"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2801100",
    "descricao": "Xampus para o cabelo",
    "ncms": [
      "33051000"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2801200",
    "descricao": "Preparações para ondulação ou alisamento, permanentes, dos cabelos",
    "ncms": [
      "33052000"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2801300",
    "descricao": "Outras preparações capilares",
    "ncms": [
      "33059000"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2801400",
    "descricao": "Tintura para o cabelo",
    "ncms": [
      "33059000"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2801500",
    "descricao": "Preparações para barbear (antes, durante ou após)",
    "ncms": [
      "33071000"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2801600",
    "descricao": "Desodorantes (desodorizantes) corporais líquidos, exceto os classificados no CEST 28.016.01",
    "ncms": [
      "33072010"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2801601",
    "descricao": "Loções e óleos desodorantes hidratantes líquidos",
    "ncms": [
      "33072010"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2801602",
    "descricao": "Antiperspirantes líquidos",
    "ncms": [
      "33072010"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2801700",
    "descricao": "Outros desodorantes (desodorizantes) corporais, exceto os classificados no CEST 28.017.01",
    "ncms": [
      "33072090"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2801701",
    "descricao": "Outras loções e óleos desodorantes hidratantes",
    "ncms": [
      "33072090"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2801702",
    "descricao": "Outros antiperspirantes",
    "ncms": [
      "33072090"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2801800",
    "descricao": "Outros produtos de perfumaria ou de toucador preparados",
    "ncms": [
      "33079000"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2801900",
    "descricao": "Outras preparações cosméticas",
    "ncms": [
      "33079000"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2802000",
    "descricao": "Sabões de toucador em barras, pedaços ou figuras moldados, exceto CEST 28.020.01",
    "ncms": [
      "34011190"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2802001",
    "descricao": "Lenços umedecidos",
    "ncms": [
      "34011190"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2802100",
    "descricao": "Outros sabões, produtos e preparações orgânicos tensoativos, inclusive papel, pastas (ouates), feltros e falsos tecidos, impregnados, revestidos ou recobertos de sabão ou de detergentes",
    "ncms": [
      "34011900"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2802200",
    "descricao": "Sabões de toucador sob outras formas",
    "ncms": [
      "34012010"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2802300",
    "descricao": "Produtos e preparações orgânicos tensoativos para lavagem da pele, em forma de líquido ou de creme, acondicionados para venda a retalho, mesmo contendo sabão",
    "ncms": [
      "34013000"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2802400",
    "descricao": "Lenços de papel, incluindo os de desmaquiar",
    "ncms": [
      "48182000"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2802401",
    "descricao": "Toalhas de mão",
    "ncms": [
      "48182000"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2802500",
    "descricao": "Apontadores de lápis para maquiagem",
    "ncms": [
      "82141000"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2802501",
    "descricao": "Espátulas, abre-cartas e raspadeiras",
    "ncms": [
      "82141000"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2802502",
    "descricao": "Lâminas de espátulas, de abre-cartas, de raspadeiras e de apontadores de lápis",
    "ncms": [
      "82141000"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2802600",
    "descricao": "Utensílios e sortidos de utensílios de manicuros ou de pedicuros (incluindo as limas para unhas)",
    "ncms": [
      "82142000"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2802700",
    "descricao": "Escovas e pincéis de barba, escovas para cabelos, para cílios ou para unhas e outras escovas de toucador de pessoas",
    "ncms": [
      "96032900"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2802701",
    "descricao": "Vassouras e escovas, mesmo constituindo partes de máquinas, de aparelhos ou de veículos, vassouras mecânicas de uso manual não motorizadas, pincéis e espanadores; cabeças preparadas para escovas, pincéis e artigos semelhantes; bonecas e rolos para pintura; rodos de borracha ou de matérias flexíveis semelhantes, outros",
    "ncms": [
      "96032900"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2802800",
    "descricao": "Pincéis para aplicação de produtos cosméticos",
    "ncms": [
      "96033000"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2802801",
    "descricao": "Pincéis e escovas, para artistas e pincéis de escrever",
    "ncms": [
      "96033000"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2802900",
    "descricao": "Vaporizadores de toucador, suas armações e cabeças de armações",
    "ncms": [
      "96161000"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2803000",
    "descricao": "Borlas ou esponjas para pós ou para aplicação de outros cosméticos ou de produtos de toucador",
    "ncms": [
      "96162000"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2803100",
    "descricao": "Malas e maletas de toucador",
    "ncms": [
      "42021"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2803200",
    "descricao": "Pentes, travessas para cabelo e artigos semelhantes; grampos (alfinetes) para cabelo; pinças (“pinceguiches”), onduladores, bobs (rolos) e artefatos semelhantes para penteados, e suas partes",
    "ncms": [
      "9615"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2803400",
    "descricao": "Chupetas e bicos para mamadeiras e para chupetas",
    "ncms": [
      "40149090"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2803500",
    "descricao": "Outras plantas e partes, para perfumaria, medicina e semelhantes",
    "ncms": [
      "12119090"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2803600",
    "descricao": "Vestuário e seus acessórios, de plásticos, inclusive luvas",
    "ncms": [
      "39262000"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2803700",
    "descricao": "Estatuetas e outros objetos de ornamentação, de plásticos",
    "ncms": [
      "39264000"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2803800",
    "descricao": "Outras obras de plásticos",
    "ncms": [
      "39269090"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2803900",
    "descricao": "Bolsas de folhas de plástico",
    "ncms": [
      "42022210"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2804000",
    "descricao": "Bolsas de matérias têxteis",
    "ncms": [
      "42022220"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2804100",
    "descricao": "Bolsas de outras matérias",
    "ncms": [
      "42022900"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2804200",
    "descricao": "Artigos de bolsos/bolsas, de outras matérias",
    "ncms": [
      "42023900"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2804300",
    "descricao": "Outros artefatos, de folhas de plásticos ou matérias têxteis",
    "ncms": [
      "42029200"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2804400",
    "descricao": "Outros artefatos, de outras matérias",
    "ncms": [
      "42029900"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2804500",
    "descricao": "Caixas e cartonagens, dobráveis, de papel/cartão, não ondulados",
    "ncms": [
      "48192000"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2804600",
    "descricao": "Outros sacos, bolsas e cartuchos, de papel ou cartão",
    "ncms": [
      "48194000"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2804700",
    "descricao": "Etiquetas de papel ou cartão, impressas",
    "ncms": [
      "48211000"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2804800",
    "descricao": "Outros impressos publicitários, catálogos comerciais e semelhantes",
    "ncms": [
      "49111090"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2804900",
    "descricao": "Outras meias de malha de outras matérias têxteis",
    "ncms": [
      "61159900"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2805000",
    "descricao": "Outros acessórios confeccionados, de vestuário",
    "ncms": [
      "62171000"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2805100",
    "descricao": "Roupas de toucador/cozinha, de tecidos atoalhados de algodão",
    "ncms": [
      "63026000"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2805200",
    "descricao": "Outros artefatos têxteis confeccionados",
    "ncms": [
      "63079090"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2805300",
    "descricao": "Chapéus e outros artefatos de outras matérias, exceto de malha",
    "ncms": [
      "65069900"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  },
  {
    "codigo": "2805400",
    "descricao": "Artigos para outras festas, carnaval ou outros divertimentos",
    "ncms": [
      "95059000"
    ],
    "segmento": "VENDA DE MERCADORIAS PELO SISTEMA PORTA A PORTA"
  }
]
